import { Trans } from 'react-i18next';
import moment from 'moment';
import SVG from 'react-inlinesvg';
import CryptoJS from 'crypto-js';
import isEmpty from 'lodash/isEmpty';
import forOwn from 'lodash/forOwn';
import isPlainObject from 'lodash/isPlainObject';
import { getContentByCurrencyLanguage, getCookie } from '@pm/super-library-2';
import { getLanguageList as getLanguageListV2, isLiteApp } from '@pm/super-library-2/utils';
import { getLiteAppAffiliate, setLiteAppAffiliate } from '@pm/super-library-2/modules/download';
import { getComm100Details } from '@pm/super-library-2/modules/member';

import { LazyLoadImage } from 'root/webapp/components/ss2/atoms/image';
import { mu_checkMyVipIsEnabled, mu_getSettingMenu } from 'root/util/member-util';
import notification from 'root/util/notification';

import { fetchMemberCPF } from '@redux/slice/user-slice';

import { popupAction, userAction, portalAction, dropdownAction, myVipAction } from '../redux/action';
import { POPUP_VIEW_TYPE } from '../redux/constant';
import { KYC_TYPES_STATUS, KYC_POPUP_INITIATE } from '../webapp/portal/settings-2/account/sub-component/profile/profile-constants_beta';
import { getListOfSupportedLanguageForUrl } from './language-util';
import core from './core';
// NOTE: This file is same as commmon-util
// MAIN PURPOSE: enhancement project performance, without import all the unused function
// The way is to export function 1 by 1 for this file
// All function name start from gu_ (general util) to indicate the function come from here

export const gu_isAppLayoutProMax = () => {
    const domain = window.location.hostname;
    const value = window.appLayoutProMax?.[domain] ?? window.appLayoutProMax;
    return value === true || value === 'true';
};

export const gu_resolveFloatingIconStyle = (vm, styleObj = {}) => {
    const resolved = gu_getContentByCurrencyLanguage(vm, styleObj);
    if (!resolved) return {};

    return Object.entries(resolved).reduce((acc, [key, value]) => {
        acc[key] = gu_getContentByCurrencyLanguage(vm, value);
        return acc;
    }, {});
};

// JSON handling
export function gu_checkIfJson(obj) {
    if (typeof obj === 'string' || obj instanceof String) {
        try {
            JSON.parse(obj);
        } catch (e) {
            return false;
        }
    } else {
        if (Array.isArray(obj)) {
            return false;
        }
        try {
            obj = JSON.stringify(obj);
            JSON.parse(obj);
        } catch (e) {
            return false;
        }
    }
    return true;
}

export function gu_jsonConcat(json1, json2, vm) {
    let jsonResult = window.SPL_Other.deepCopy(json1);

    for (var key in json2) {
        let certainTranslate = gu_getContentByCurrencyLanguage(vm, json2[key]);

        if (!(json2 && json2[key] && json2[key].disableDefaultTranslate && !certainTranslate)) {
            jsonResult[key] = json2[key];
        }
    }

    return jsonResult;
}

// combine n jsons into 1
export function gu_jsonConcats(vm, ...jsons) {
    return jsons.reduce((pre, cur) => gu_jsonConcat(pre, cur, vm), {});
}

// String handling
export function gu_replaceAll(str, search, replacement) {
    return str.replace(new RegExp(search, 'g'), replacement);
}

export function gu_replaceSubString(str, firstKey, replacement, lastKey, condition) {
    if (str.indexOf(firstKey) === -1 || str.lastIndexOf(lastKey) === -1) return str;
    if (!condition) return gu_replaceAll(str, firstKey, replacement);
    return str.replace(str.substring(str.indexOf(firstKey), str.lastIndexOf(lastKey) + lastKey.length), replacement);
}

export function gu_getByViewType(obj, vm) {
    if (!vm) {
        alert('vm is not valid/passed into function getByViewType()');
        return;
    }

    const { screen } = vm.props;
    let viewType = 'web'; // default if not found
    if (screen && screen.viewType) {
        viewType = screen.viewType;
    }
    return obj && (obj[viewType] || obj[viewType] === '' || typeof obj[viewType] === 'boolean') ? obj[viewType] : obj;
}

export const gu_getContentBaseOnLoginStatus = (content, isLogin) => {
    const key = isLogin ? 'afterLogin' : 'beforeLogin';

    return content?.[key] ?? content;
};

export function gu_getContentByCurrencyLanguage(vm, content, countryLanguageKeySettings = {}) {
    let countryLanguageKey = null;
    let country = null;
    let currency = null;
    let languageKey = null;

    if (vm && vm.props && content) {
        const { language } = vm.props;
        let user = null;

        // Step 1: Get selected currency and language
        // Step 1.0: Get language key
        if (vm.props.oriProps && vm.props.oriProps.language) {
            languageKey = vm.props.oriProps.language.key;
            country = vm.props.oriProps.language.country;
        } else if (vm.props.language) {
            languageKey = vm.props.language.key;
            country = vm.props.language.country;
        }

        // used for the case if some content got manual get by language.toLowerCase()
        if (content.convertLangToLowerCase) {
            languageKey = languageKey.toLowerCase();
        }

        // Step 1.1: Check if login, get account currency
        if (vm.props.oriProps) {
            if (vm.props.oriProps.user && vm.props.oriProps.user.isLogin) {
                user = vm.props.oriProps.user;
            }
        } else if (vm.props.user && vm.props.user.isLogin) {
            user = vm.props.user;
        }

        const convertUSD = () => {
            if (vm.props.oriProps) {
                currency = vm.props.oriProps.language.country + vm.props.currencyLang;
            } else if (countryLanguageKeySettings && countryLanguageKeySettings.convertUSD) {
                currency = vm.props.language.country + (language && language.currencyLang);
            }
        };

        if (user && user.account) {
            currency = user.account.actualCurrency || user.account.currency;
            if (currency === 'USD' || currency === 'EUR') {
                convertUSD();
            }
        }

        // Step 1.2: If not login, get current currencyLang based on language selected
        if (!currency) {
            if (vm.props.currencyLang || (language && language.currencyLang)) {
                currency = vm.props.currencyLang || (language && language.currencyLang);
                if (currency === 'USD' || currency === 'EUR') {
                    convertUSD();
                }
            }
        }
        if (currency && currency.currencyLang) {
            currency = currency.currencyLang;
        }

        // Step 2: Get content
        // Step 2.1: Check if content contains selected currency
        if (content[country] || typeof content[country] === 'boolean') {
            const regionContent = content[country];
            if (regionContent[languageKey] || typeof regionContent[languageKey] === 'boolean') {
                return regionContent[languageKey];
            }
            return regionContent;
        } else if (content[currency] || typeof content[currency] === 'boolean') {
            let selectedContentJson = content[currency];
            if (selectedContentJson[languageKey] || typeof selectedContentJson[languageKey] === 'boolean') {
                // Step 2.1.1: Get correct currency > languageKey
                return selectedContentJson[languageKey];
            } else if ((selectedContentJson['en'] || typeof selectedContentJson['en'] === 'boolean') && !selectedContentJson.disableDefaultTranslate) {
                // Step 2.1.2: Get default languageKey 'en'
                return selectedContentJson['en'];
            } else if (selectedContentJson.disableDefaultTranslate || countryLanguageKeySettings.disableDefaultTranslate) {
                return null;
            } else {
                return selectedContentJson;
            }
        } else if (content['ALL'] || typeof content['ALL'] === 'boolean') {
            // Step 2.2: Check if having general translate for all language
            let selectedContentJson = content['ALL'];
            if (selectedContentJson[languageKey] || typeof selectedContentJson[languageKey] === 'boolean') {
                // Step 2.2.1: Get correct currency > languageKey
                return selectedContentJson[languageKey];
            } else if (
                (selectedContentJson['en'] || typeof selectedContentJson['en'] === 'boolean') &&
                !selectedContentJson.disableDefaultTranslate &&
                !countryLanguageKeySettings.disableDefaultTranslate
            ) {
                // Step 2.2.2: Get default languageKey 'en'
                return selectedContentJson['en'];
            } else if (selectedContentJson.disableDefaultTranslate || countryLanguageKeySettings.disableDefaultTranslate) {
                return null;
            } else {
                return selectedContentJson;
            }
        } else {
            // If content already filter/without currency, direct take content by language
            // **Not recommended, try to avoid
            if (content.dynamicImageReferralBackground) {
                return content?.[vm.props?.language?.countryLanguageKey?.toLowerCase()] || '';
            } else if ((content[languageKey] || typeof content[languageKey] === 'boolean') && !content.disableLangProps) {
                return content[languageKey];
            } else if ((content['en'] || typeof content['en'] === 'boolean') && !content.disableDefaultTranslate && !countryLanguageKeySettings.disableDefaultTranslate) {
                return content['en'];
            } else if (content.disableDefaultTranslate || countryLanguageKeySettings.disableDefaultTranslate) {
                return null;
            }

            // Step 3: Fallback control - used for countryLanguage key like en-my, ms-my
            if (vm.props.language && vm.props.language.countryLanguageKey) {
                countryLanguageKey = vm.props.language.countryLanguageKey;
            } else if (vm.props.countryLanguageKey) {
                countryLanguageKey = vm.props.countryLanguageKey;
            }
            let defaultCountryLanguageKey = window.countryLanguageKey;

            if (!countryLanguageKeySettings.noLowerCase) {
                countryLanguageKey = countryLanguageKey.toLowerCase();
                defaultCountryLanguageKey = defaultCountryLanguageKey.toLowerCase();
            }
            if (!countryLanguageKeySettings.showUnderScore) {
                countryLanguageKey = countryLanguageKey.replace('_', '-');
                defaultCountryLanguageKey = defaultCountryLanguageKey.replace('_', '-');
            }

            if (countryLanguageKey && content[countryLanguageKey]) {
                // Step 3.1: Try to get current countryLanguageKey
                return content[countryLanguageKey];
            } else if (content[defaultCountryLanguageKey]) {
                // Step 3.2: Try to get default countryLanguageKey
                return content[defaultCountryLanguageKey];
            } else {
                return content; // Return back contnet if all condition does not match
            }
        }
    } else {
        return content;
    }
}

export function gu_getRecommendedCasino(vm) {
    window.SPL_Content.getRecommendCasino().then((res) => {
        if (res) {
            let content = gu_getContentByCurrencyLanguage(vm, res);
            vm.setState({ recommendedCasinoGames: content }, () => {
                if (vm.state.updateState) {
                    gu_updateComponentProps(vm, 'liveCasinoSliderProps', { recommendedCasinoGames: content });
                }
            });
        }
    });
}

export async function gu_getMemberBankSVGData(vm, memberBankList) {
    const enableMemberBankSVGData = gu_getSettingFromPortalSettings({
        vm: vm,
        settingName: 'enableMemberBankSVGData',
        defaultValue: false,
    });
    if (enableMemberBankSVGData) {
        let memberBankPromises = [];
        for (let i = 0; i < memberBankList.length; i++) {
            let memberBank = memberBankList[i];
            const bankCode = memberBank.code || memberBank.bankCode;
            memberBankPromises.push(window.SPL_Other.renderTemplateSVG(`${gu_getDepositImgPath(vm, 'bank')}${bankCode}.svg`, `${bankCode}`));
        }

        Promise.all(memberBankPromises).then((results) => {
            for (let i = 0; i < results.length; i++) {
                memberBankList[i].svgData = results[i];
            }

            // force UI render after svgData
            vm.setState({});
        });
    }
}

// this function is to handle e/e.target.value
// e.g. onClick pass index as e/ onChange pass index as e
// but still recommend direct pass e.target.value, if not need special handling like this
export function gu_massageIndex(e) {
    let massagedIndex = e;
    if (e && e.target) {
        massagedIndex = e.target.customValue ? e.target.customValue : e.target.value;
    } else if (e || e === 0) {
        massagedIndex = e;
    }
    return massagedIndex;
}

export function gu_getFilterPathname(withCategory = false) {
    let path = window.location.pathname;
    let index = path.lastIndexOf('/', path.lastIndexOf('/') - 1);
    let pathWithCategory = path.slice(index); // get string start from last 2nd "/" e.g. /slots or /casino
    path = path.slice(path.lastIndexOf('/') + 1); //get string start from last "/" e.g. spadeGaming

    if (withCategory) {
        return pathWithCategory;
    } else {
        return path;
    }
}

export function gu_togglePopup(vm, component, customPopUpContent) {
    let popupCollection = vm.state.popupCollection ? vm.state.popupCollection : {};
    popupCollection[component] = !popupCollection[component];
    vm.setState({
        popupCollection,
        customPopUpContent,
    });
}

export function gu_scrollIntoView(id) {
    const target = document.getElementById(id);
    target && target.scrollIntoView();
}

// NOTE: there's no model for me to put these
let isScrollIntoViewOnMount = false;
export function gu_setScrollIntoViewOnMount(flag) {
    isScrollIntoViewOnMount = flag;
}

export function gu_getScrollIntoViewOnMount() {
    return isScrollIntoViewOnMount;
}

export function gu_pushLocationWithPromise(vm, location) {
    return new Promise((resolve) => {
        const { history } = vm.props;

        history.push(location);

        resolve();
    });
}

export function gu_saveSingleData(vm, data) {
    vm.setState({ singleData: data });
}

export function portalIsLoading(props, flag) {
    props.dispatch(portalAction.portalIsLoading(flag));
}

// if pathname match the specific pathname, will get the menus
// didupdate
export function gu_getMobileNavMenu(vm) {
    const { menuByPathSettings, affMenuByPathSettings } = vm.state.compSettings;
    const { location, menuSlice } = vm.props;

    return new Promise((resolve) => {
        let filterJSON = (menuByPathSettings || []).find((e) => location.pathname.startsWith(e.pathname));
        if (window.isAffiliate) {
            filterJSON = (affMenuByPathSettings || []).find((e) => location.pathname.startsWith(e.pathname));
        }

        // temp solution to handle different path requriements
        if (location.pathname === '/blog' && location.pathname === filterJSON?.pathname) {
            vm.setState({ displayMenuByPathSettings: null, enableMenuByPath: false }, resolve());
            return;
        }

        if (filterJSON) {
            // if got prefix, will assume take menu's submenu
            if (filterJSON.prefix) {
                const providerSubmenu = menuSlice?.processedBaseMenuSettings?.subCategoryMenus?.[filterJSON.prefix] || [];
                vm.setState({ providerMenu: providerSubmenu });
            } else {
                mu_getSettingMenu(vm);
            }

            // displayMenuByPathSettings used for html handling, logic will be similar here
            vm.setState({ displayMenuByPathSettings: filterJSON, enableMenuByPath: true, isProviderPage: true }, resolve());
        } else {
            vm.setState({ displayMenuByPathSettings: null, enableMenuByPath: false }, resolve());
        }
    });
}

// Params
// vm (Required) -> this
// settingName (Required) -> the name of setting is getting
// defaultValue -> return specific value if setting not found
// notFeatures -> if the setting not inside features set true
// notViewType -> if the setting not contain 'web' and 'mobile' set true
// isCurrencyLang -> if the setting is define by CurrencyLanguage or countryLanguageKey
// isAffFeatures -> get settings from affFeatures instead of features
export function gu_getSettingFromPortalSettings(params) {
    const { vm, settingName } = params;
    let settingObj = null;

    if (vm && vm.props) {
        let portalSettingsReducer = vm.props.portalSettingsReducer;

        // Get the settings out from portal settings
        if (params.notFeatures) {
            if (portalSettingsReducer && portalSettingsReducer.portalSettings && portalSettingsReducer.portalSettings[settingName]) {
                settingObj = portalSettingsReducer.portalSettings[settingName];
            }
        } else {
            let featureObj = gu_getFeaturesFromPortalSettings(vm, params.isAffFeatures);
            if (featureObj) {
                settingObj = featureObj[settingName];
            }
            // if (params.isAffFeatures) {
            //     if (portal && portal.settings && portal.settings.affFeatures && portal.settings.affFeatures[settingName]) {
            //         settingObj = portal.settings.affFeatures[settingName];
            //     }
            // } else {
            //     if (portal && portal.settings && portal.settings.features && portal.settings.features[settingName]) {
            //         settingObj = portal.settings.features[settingName];
            //     }
            // }
        }

        if (settingObj) {
            // Check screen view type
            if (!params.notViewType) {
                settingObj = gu_getByViewType(settingObj, vm);
            }

            // Check if currency language needed
            if (params.isCurrencyLang) {
                settingObj = gu_getContentByCurrencyLanguage(vm, settingObj);
            }
        }
    } else {
        alert('Error! Calling getSettingFromPortalSettings function without vm / settingName');
    }

    if (settingObj) {
        return gu_deepCopy(settingObj);
    } else if (!settingObj && params.defaultValue !== undefined) {
        return gu_deepCopy(params.defaultValue);
    } else {
        return {};
    }
}

// Params
// vm (Required) -> this
// settingName (Required) -> the name of setting is getting
// defaultValue -> return specific value if setting not found
// notFeatures -> if the setting not inside features set true
// notViewType -> if the setting not contain 'web' and 'mobile' set true
// isCurrencyLang -> if the setting is define by CurrencyLanguage or countryLanguageKey
// isAffFeatures -> get settings from affFeatures instead of features
export function gu_getFeaturesFromPortalSettings(vm, isAffFeatures = false) {
    const { portalSettingsReducer } = vm.props;

    if (portalSettingsReducer && portalSettingsReducer.portalSettings) {
        if (isAffFeatures) {
            if (portalSettingsReducer.portalSettings.affFeatures) {
                return portalSettingsReducer.portalSettings.affFeatures;
            }
        } else {
            if (portalSettingsReducer.portalSettings.features) {
                return portalSettingsReducer.portalSettings.features;
            }
        }
    }
    return {};
}

export function gu_togglePromptSelect(vm, name, enable) {
    let promptSelect = vm.state.promptSelect;
    if (!promptSelect) {
        promptSelect = {};
    }
    promptSelect[name] = enable ? true : false;
    vm.setState({ promptSelect });
}

// vm -> this
// componentName -> the component's prop name
// propAndValues -> the updated data to be assigned back to the component
export function gu_updateComponentProps(vm, componentName, propAndValues, callback) {
    let { compSettings } = vm.state;
    let compObjects = '';
    let propKeys = Object.keys(propAndValues);

    if (componentName.constructor === Array) {
        for (let i = 0; i < componentName.length; i++) {
            compObjects = compSettings[componentName[i]];

            assignCompObjects(compObjects);
        }
    } else {
        compObjects = compSettings[componentName];

        assignCompObjects(compObjects);
    }

    function assignCompObjects(compObject) {
        for (let i = 0; i < propKeys.length; i++) {
            let key = propKeys[i];

            assignIfValid(compObject, key, propAndValues[key]);
        }
    }

    function assignIfValid(component, key, value) {
        if (component && Object.keys(component).indexOf(key) > -1) {
            component[key] = value;
        }

        return component;
    }

    vm.setState({ compObjects }, () => {
        if (callback) {
            callback();
        }
    });
}

export function gu_replaceCustomTranslationMinMax(translation, min, max, currency = '') {
    if (!translation) return '';

    let finalTranslation = translation;
    if (currency) {
        finalTranslation = finalTranslation.replace(/{currency}/gi, currency);
    } else {
        finalTranslation = finalTranslation.replace(/{currency}/gi, '').replace(/\s{2,}/g, ' ');
    }
    finalTranslation = finalTranslation.replace(/{min-amount}/gi, min);
    finalTranslation = finalTranslation.replace(/{max-amount}/gi, max);
    return finalTranslation;
}

export function gu_formatDepositPlaceholder({ customText, min, max, t, currency }) {
    const formattedMin = window.SPL_Other.formatAmount(min);
    const formattedMax = window.SPL_Other.formatAmount(max, t);

    if (customText) {
        return gu_replaceCustomTranslationMinMax(customText, formattedMin, formattedMax, currency);
    } else {
        return t('global:global.form.online-transfer-amount-placeholder', {
            min: formattedMin,
            max: formattedMax,
        });
    }
}

// add showCurrencyInTooltip: true to show currency in tooltip, may refer transaction-form-amount_beta.js
// showCurrencyInTooltip:true currently only for deposit page
export function gu_formatMinMaxTooltip({ customText, min, max, t, fallbackKey, currency = '', showCurrency = false }) {
    const minFormatted = window.SPL_Other.formatAmount(min);
    const maxFormatted = window.SPL_Other.formatAmount(max);
    const displayCurrency = showCurrency ? currency : '';
    const text = customText || t(fallbackKey || 'transaction:transaction.deposit.cashdeposit.min/maxlimit');

    return `${text} ${displayCurrency} ${minFormatted} / ${displayCurrency} ${maxFormatted}`.trim();
}

// return true when it's a img path
export function gu_isImg(strPath) {
    let regex = /[/.](gif|jpg|jpeg|tiff|png)$/i;
    return regex.test(strPath);
}

export function gu_checkIOSDownloadLink() {
    return new Promise(function (resolve) {
        window.SPL_Content.getAppLandingDataSp2().then((res) => {
            if (res) {
                window.SPL_JsonSettings.getAppDownloadLinkJson((data) => {
                    let camoData = gu_getNestedValue(data, 'camouflageapp');
                    if (data && data.ios && data.ios !== '') {
                        resolve(true);
                    } else if (camoData && camoData.ios && camoData.ios !== '') {
                        resolve(true);
                    } else {
                        let tabList = res.appDownloadData.tabList;
                        let filterTabList = (tabList || []).filter(function (el) {
                            return el.tabName === 'iosapp' || el.tabName === 'androidapp';
                        });
                        if (filterTabList.length > 0) {
                            resolve(true);
                        } else {
                            resolve(false);
                        }
                    }
                });
            }
        });
    });
}

export function gu_commonHrefRedirect(url, vm, noRedirectIfSameRoute) {
    if (noRedirectIfSameRoute && window.location.pathname.includes(url)) {
        return;
    }
    let check = url.charAt(0);
    let checkHttp = url.substring(0, 4);
    if (check !== '/' && checkHttp !== 'http') {
        vm.props.history.push('/' + url);
    } else if (check === '/' && checkHttp !== 'http') {
        vm.props.history.push(url);
    } else if (check !== '/' && checkHttp === 'http') {
        window.open(url, '');
    }
}

export function gu_getLanguageList(vm) {
    let res = {
        languageList: [],
        currentLanguage: {},
    };

    return new Promise((resolve) => {
        // window.SPL_Content.getLanguageList(vm.props).then((data) => {
        let data = getLanguageListV2(window?.portalSettings);
        const { user } = vm.props;
        const { compSettings } = vm.state;
        const { portalSettings } = vm.props.portalSettingsReducer;

        let currentLanguage = {},
            countryLanguageKey = vm.props.language.countryLanguageKey;

        for (let i = 0; i < data.length; i++) {
            let languages = data[i].languages;
            for (let j = 0; j < languages.length; j++) {
                if (languages[j].countryLanguageKey === countryLanguageKey) {
                    Object.assign(currentLanguage, languages[j]);
                }
            }
        }
        res.currentLanguage = currentLanguage;

        if (compSettings && compSettings.internationalFeature && user.isLogin && user.account.country) {
            let internationalData = data.filter(function (a) {
                let language = a.languages.some(function (b) {
                    if (b.countryCode.toUpperCase() === user.account.country) {
                        return b.countryCode.toUpperCase() === user.account.country;
                    }
                    return false;
                });
                return language;
            });

            if (internationalData.length <= 0) {
                internationalData = data.filter((a) => a.countryName === 'International');
            }

            data = internationalData;
        }

        if (portalSettings && portalSettings.features && portalSettings.features.languageModalOrdering) {
            let sort = gu_changeLanguageArrangementSort(portalSettings.features.languageModalOrdering, data);
            if (sort) {
                data = sort;
            }
        }

        res.languageList = data;
        resolve(res);
        // });
    });
}

export function commonAuthenticatedAction(vm, callback, customCallback) {
    const props = vm.props;

    const isKycSumsubEnabled = props.portalSettingsReducer?.portalSettings?.features?.kycSumsub?.isEnabled;
    props.dispatch(userAction.isAuthenticated(props)).then(() => {
        const { user, dispatch } = vm.props;

        if (customCallback) {
            customCallback();
            return;
        }

        if (!window.isAgent && !window.isAffiliate) {
            gu_checkForceChangePasswordPopUp(vm);
            gu_getMemberKYCData(vm);
            if (isKycSumsubEnabled) {
                gu_getSumsubData(vm);
            }
            gu_getMemberCPF(user, dispatch);
            vm.props.dispatch(userAction.updateUserVerifications(vm.props));

            mu_checkMyVipIsEnabled(vm).then((data) => {
                if (data) {
                    vm.props.dispatch(myVipAction.fetchVipBonusInfo()).catch(() => {});
                }
            });
        }

        callback && callback();
    });
}

export function gu_checkForceChangePasswordPopUp(vm) {
    const props = vm.props;
    const { portalSettings } = props.portalSettingsReducer;

    // NOTE: seems like BE handled, add back = =
    if (portalSettings && portalSettings.promptChangePassword) {
        if (props.user && props.user.account && props.user.account.requiredResetPassword) {
            props.dispatch(popupAction.togglePopUp({ popupType: POPUP_VIEW_TYPE.CHANGE_PASSWORD }));
        }
    }
}

export function gu_getMemberKYCData(vm, isInit = true) {
    const { dispatch, user, portalSettingsReducer } = vm.props;

    // exit if kyc setting is off
    if (portalSettingsReducer && portalSettingsReducer.portalSettings && !portalSettingsReducer.portalSettings.enableKYC) return;

    window.SPL_Member.getMemberKYCData()
        .then((data) => {
            if (data) {
                let kycToUpdateList = [];

                // NOTE: wtf data became array
                const _data = data[0];
                const mainStatus = _data.status;
                const reinitiate = _data.reinitiate;
                if (_data && _data.kycTypes && _data.kycTypes.length > 0) {
                    let existingKYCUpload = {};
                    const { kycTypes } = _data;
                    for (let i = 0, l = kycTypes.length; i < l; i++) {
                        const { kycType, status, imagePath } = kycTypes[i];
                        if (status === KYC_TYPES_STATUS.PENDING) kycToUpdateList.push(kycType);

                        if (imagePath && (status === KYC_TYPES_STATUS.APPROVED || status === KYC_TYPES_STATUS.PENDING)) {
                            existingKYCUpload[kycType] = {};
                            existingKYCUpload[kycType].imagePath = imagePath;
                            existingKYCUpload[kycType].name = imagePath.substring(imagePath.lastIndexOf('/') + 1, imagePath.length);
                        }
                    }

                    vm.setState?.({ existingKYCUpload });

                    let account = user.account;
                    account.memberKYCData = _data;
                    dispatch(userAction.updateCertainUser(account));
                }

                if (isInit && mainStatus === KYC_TYPES_STATUS.INITIATE && !reinitiate && kycToUpdateList.length) {
                    dispatch(
                        popupAction.togglePopUp({
                            popupType: POPUP_VIEW_TYPE.KYC_NOTIFICATION,
                            popupProps: {
                                kycToUpdateList: kycToUpdateList,
                            },
                        }),
                    );
                } else if (isInit && [KYC_TYPES_STATUS.PENDING, KYC_TYPES_STATUS.INITIATE].includes(mainStatus) && reinitiate && kycToUpdateList.length) {
                    dispatch(
                        popupAction.togglePopUp({
                            popupType: POPUP_VIEW_TYPE.KYC_NOTIFICATION,
                            popupProps: {
                                kycToUpdateList: kycToUpdateList,
                                reinitiate: reinitiate,
                            },
                        }),
                    );
                }
            }
        })
        .catch(() => {});
}

export function gu_getSumsubData(vm) {
    const { dispatch } = vm.props;

    window.SPL_Member.getMemberKycStatus()
        .then((data) => {
            const applicants = data?.applicants ?? [];
            const initByCompliance = data?.source === KYC_POPUP_INITIATE.COMPLIANCE || false;
            const displayNotification = data?.displayNotification || false;

            if (applicants.length === 0) return;

            const activeLevel = applicants.find((item) => item?.isActiveLevel === true);

            if (activeLevel && initByCompliance && displayNotification) {
                const { applicantLevel, applicantStatus } = activeLevel;
                const sumsubMemberKycStatus = applicantStatus || data?.sumsubMemberKYCStatus || 'Pending';

                dispatch(
                    popupAction.togglePopUp({
                        popupType: POPUP_VIEW_TYPE.SUMSUB,
                        popupProps: {
                            sumsubMemberKycStatus,
                            applicantLevel,
                        },
                    }),
                );
                try {
                    window.SPL_Member.updateSumsubNotification();
                } catch (err) {
                    console.warn('Failed to update Sumsub notification:', err);
                }
            }

            dispatch(userAction.getMemberKYCSumsubInfo(data));
        })
        .catch((error) => {
            console.error('Error fetching member KYC status:', error);
        });
}

export function gu_getMemberCPF(user, dispatch) {
    const { currency } = user?.account || {};
    const isValidCurrency = currency === 'BRL';

    // exit if currency not valid
    if (!isValidCurrency) return;

    dispatch(fetchMemberCPF());
}

export function convertStringToCapitalize(string) {
    const lowerString = string.toLowerCase();
    const arr = lowerString.split(' ');
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
    }
    const capitalString = arr.join(' ');
    return capitalString;
}

// Get Custom Translation from /public/html/settings/custom-translation.json
// (Parameter) currentPage: refer as the page requesting and the key of the custom-translation.json
export function gu_loadCustomTranslation(currentPage, vm, callback) {
    let customTranslationObj = {};
    let countryLanguageKey = null;
    let combinedPagesTranslation = {};
    const { features } = vm.props?.portalSettingsReducer?.portalSettings || {};

    if (vm.props.language && vm.props.language.countryLanguageKey) {
        countryLanguageKey = vm.props.language.countryLanguageKey.toLowerCase();
    } else if (vm.props.countryLanguageKey) {
        countryLanguageKey = vm.props.countryLanguageKey.toLowerCase();
    }

    if (countryLanguageKey === null) {
        return;
    }

    if (features?.loadCustomTranslation) {
        window.SPL_Content.getCustomTranslation().then((data) => {
            if (Array.isArray(currentPage)) {
                let tempPageKeyi18n = [];
                for (let i = 0; i < currentPage.length; i++) {
                    // pageKey = currentPageKey
                    let pageKey = currentPage[i];
                    if (data && data[countryLanguageKey] && data[countryLanguageKey][pageKey]) {
                        tempPageKeyi18n.push(gu_getByViewType(data[countryLanguageKey][pageKey], vm));
                        if (i === 0) {
                            combinedPagesTranslation = tempPageKeyi18n[0];
                        } else if (i > 0 && tempPageKeyi18n[i - 1]) {
                            combinedPagesTranslation = gu_jsonConcat(combinedPagesTranslation, tempPageKeyi18n[i]);
                        }
                    } else if (data && data[pageKey]) {
                        let filteredData = gu_getContentByCurrencyLanguage(vm, data[pageKey], { showUnderScore: true });
                        filteredData = gu_getByViewType(filteredData, vm);
                        if (filteredData) {
                            for (let key in filteredData) {
                                if (typeof filteredData[key] === 'object') {
                                    filteredData[key] = gu_getContentByCurrencyLanguage(vm, filteredData[key], { showUnderScore: true });
                                }
                            }
                            tempPageKeyi18n.push(filteredData);
                            if (i === 0) {
                                combinedPagesTranslation = tempPageKeyi18n[0];
                            } else if (i > 0 && tempPageKeyi18n[i - 1]) {
                                combinedPagesTranslation = gu_jsonConcat(combinedPagesTranslation, tempPageKeyi18n[i]);
                            }
                        }
                    }
                }
                customTranslationObj = combinedPagesTranslation;
            } else {
                if (data && data[countryLanguageKey] && data[countryLanguageKey][currentPage]) {
                    customTranslationObj = gu_getByViewType(data[countryLanguageKey][currentPage], vm);
                } else if (data && data[currentPage]) {
                    let filteredData = gu_getContentByCurrencyLanguage(vm, data[currentPage], { showUnderScore: true });
                    filteredData = gu_getByViewType(filteredData, vm);
                    if (filteredData) {
                        for (let key in filteredData) {
                            if (typeof filteredData[key] === 'object') {
                                filteredData[key] = gu_getContentByCurrencyLanguage(vm, filteredData[key], { showUnderScore: true });
                            }
                        }
                        customTranslationObj = filteredData;
                    }
                }
            }

            vm.setState({ customTranslationObj }, () => {
                callback && callback();
            });
        });
    } else {
        vm.setState({ customTranslationObj }, () => {
            callback && callback();
        });
    }
}

export function gu_getAffiliateLink(vm, withTimeout = true) {
    const { countryLanguageKey, language, portalSettingsReducer } = vm.props;
    let languageKey = null;
    if (countryLanguageKey) {
        languageKey = countryLanguageKey;
    } else if (language && language.countryLanguageKey) {
        languageKey = language.countryLanguageKey;
    }
    if (withTimeout) {
        setTimeout(() => {
            getAndSetAffiliateLink();
        }, 1000);
    } else {
        getAndSetAffiliateLink();
    }

    function getAndSetAffiliateLink() {
        let isAffiliate = false;
        if (window.isAffiliate) {
            isAffiliate = true;
        }
        window.SPL_Content.displayAffiliateLink(isAffiliate, languageKey).then((res) => {
            const forceShowAffiliate = portalSettingsReducer?.portalSettings?.features?.forceShowAffiliate;

            vm.setState(
                {
                    showAffiliate: res.showAffiliate,
                    forceShowAffiliate,
                },
                () => {
                    if (vm.state.updateState) {
                        gu_updateComponentProps(vm, 'inforCenterProps', { showAffiliate: res.showAffiliate });
                    }

                    let showAffiliate = vm.state.showAffiliate;
                    if (showAffiliate || forceShowAffiliate) {
                        let domain = window.location.hostname;
                        const affid = window.SPL_Cookie.getCookie('AffCode');
                        const affParam = affid !== null ? `?affid=${affid}` : '';
                        // task 40901, default all use same domain name to redirect to affiliate portal
                        // only when useAffiliateUrl flag is enabled only will use portal setting value
                        if (portalSettingsReducer?.portalSettings?.features?.useAffiliateUrl) {
                            const affiliateUrl = portalSettingsReducer.portalSettings.affiliateUrl + affParam;
                            vm.setState({ affiliateLink: affiliateUrl }, () => {
                                if (vm.state.updateState) {
                                    gu_updateComponentProps(vm, 'inforCenterProps', { affiliateLink: affiliateUrl });
                                }
                            });
                        } else if (portalSettingsReducer?.portalSettings?.features?.useLanguageAffiliateUrl?.[languageKey]) {
                            const affiliateUrl = portalSettingsReducer.portalSettings.features.useLanguageAffiliateUrl[languageKey] + affParam;
                            vm.setState({ affiliateLink: affiliateUrl }, () => {
                                if (vm.state.updateState) {
                                    gu_updateComponentProps(vm, 'inforCenterProps', {
                                        affiliateLink: affiliateUrl,
                                    });
                                }
                            });
                        } else {
                            // only work in staging, uat and prod environment
                            const testEnvRegex = /^[a-z0-9-]+-(uat|staging).*\.(super|ttwd).*/;
                            const isStagingUat = testEnvRegex.test(domain);

                            const liteAppPrefix = 'lite-app';

                            let affiliateDomain = window.location.protocol + '//';
                            if (isStagingUat) {
                                domain = domain.replace('staging2.', 'staging.');
                                domain = domain.replace('uat2.', 'uat.');
                                domain = 'aff-' + domain;
                            } else if (domain.indexOf(liteAppPrefix) !== -1) {
                                domain = domain.replace(liteAppPrefix, 'aff');
                            } else {
                                let prefixList = ['www.', 'member.']; // need do as server settings for prefix list if more in future
                                let isPrefixFound = false;

                                for (let i = 0; i < prefixList.length; i++) {
                                    if (domain.includes(prefixList[i])) {
                                        isPrefixFound = true;
                                    }
                                    domain = domain.replace(prefixList[i], 'aff.');
                                }
                                if (!isPrefixFound) {
                                    domain = 'aff.' + domain;
                                }
                            }
                            affiliateDomain += domain;

                            if (
                                portalSettingsReducer &&
                                portalSettingsReducer.portalSettings &&
                                portalSettingsReducer.portalSettings.features &&
                                portalSettingsReducer.portalSettings.features.directAffiliateToCorrectLanguage
                            ) {
                                let languageOri = languageKey.replace('_', '-');
                                let language = languageOri.toLowerCase();

                                affiliateDomain = affiliateDomain + '/' + language;
                            }

                            affiliateDomain += affParam;
                            vm.setState({ affiliateLink: affiliateDomain }, () => {
                                if (vm.state.updateState) {
                                    gu_updateComponentProps(vm, 'inforCenterProps', { affiliateLink: affiliateDomain });
                                }
                            });
                        }
                    }
                },
            );
        });
    }
}

let commonUtilExternalMerchantAction = [];
export function gu_triggerAdElementAction(action, extraParam) {
    if (window.externalMerchantAction && window.externalMerchantAction[action]) {
        const wrappedExternalFunc = () => {
            const externalFunc = window.externalMerchantAction[action];
            externalFunc(extraParam, () => {
                commonUtilExternalMerchantAction.shift();
                if (commonUtilExternalMerchantAction.length) commonUtilExternalMerchantAction[0]();
            });
        };

        commonUtilExternalMerchantAction.push(wrappedExternalFunc);
        if (commonUtilExternalMerchantAction.length === 1) commonUtilExternalMerchantAction[0]();
    }
}

export function gu_getNestedValue(obj, key) {
    try {
        if (key) {
            key = key.replace(/\[(\w+)\]/g, '.$1'); // split indexes.
            key = key.replace(/^\.+/, ''); // remove leading dot.
            const a = key.split('.');
            for (var i = 0, n = a.length; i < n; ++i) {
                var k = a[i];
                if (k in obj) {
                    obj = obj[k];
                } else {
                    return;
                }
            }
        }

        return obj;
    } catch (err) {
        return undefined;
    }
}

export function gu_filterCommonKey(parentElement = false, childElement = false, filterSettings = {}) {
    let params = {
        loop: filterSettings?.loop || false, // use for filter multi key, eg: web: { THB: { en: "test" } }
        baseOnUserCurrency: filterSettings?.baseOnUserCurrency || false, // currency will get member currency
        customFilterKeys: filterSettings?.customFilterKeys || [], // use for filter special key
    };

    return window.SPL_Content.filterCommonKeyHandler(gu_getNestedValue(parentElement, childElement), params);
}

export function gu_updateOldData_with_newData(dataSelected, customData = false, customFilterKeys = []) {
    return window.SPL_Content.updateOldData_with_newData(dataSelected, customData, customFilterKeys);
}

export function gu_generateComponent(data) {
    if (data) {
        // 1. Filter Data
        data = gu_filterCommonKey(data);
        let tempData = data.constructor === Object ? { ...data } : data;

        // 2. Pass data and do checking
        return dataHandler(tempData);
    } else {
        return false;
    }

    // 3. Checking Flow
    function dataHandler(data) {
        if (data && data.constructor === Array) {
            let arrContent = data;
            let container = [];

            for (let i = 0; i < arrContent.length; i++) {
                let arrData = arrContent[i];
                // Will push the data to "container" to create a new Array(Object)
                container.push(objHandler(arrData, i));
            }

            return container;
        } else {
            // if the data is an object
            return objHandler(data);
        }

        // 4. Object Checking
        function objHandler(objData, i = null) {
            let TAG = 'div';
            let customClass = '';
            let content = '';
            let style = '';

            // Filter objData
            objData = gu_filterCommonKey(objData);

            if (objData.className) customClass = gu_filterCommonKey(objData.className);
            if (objData.content) content = gu_filterCommonKey(objData.content);
            if (objData.style) style = gu_filterCommonKey(objData.style);
            if (objData.tag === '') {
                TAG = objData.tag;
            } else if (objData.tag) {
                TAG = gu_filterCommonKey(objData.tag);
            }

            let component = (
                <TAG key={i} className={customClass} style={{ ...style }}>
                    {content}
                </TAG>
            );
            // ================== CHECKING CONTENT PART =======================
            // When content is Array will loop back to "dataHandler" to check again
            if (content && content.constructor === Array) {
                return (
                    <TAG key={i} className={customClass} style={{ ...style }}>
                        {dataHandler(content)}
                    </TAG>
                );

                // When content is Object will run "objHandler" again to display content
            } else if (content && content.constructor === Object) {
                return (
                    <TAG key={i} className={customClass} style={{ ...style }}>
                        {objHandler(content)}
                    </TAG>
                );

                // When tag is image will display the content using LazyLoadImage
                // If tag is empty will use content parent tag
            } else {
                if (TAG === '') component = content;
                if (TAG === 'img') component = <LazyLoadImage key={i} src={content} className={customClass} style={{ ...style }} />;

                return component;
            }
            // ================== CHECKING CONTENT PART =======================
        }
    }
}

export function gu_showHomeWithoutUrl(vm, features) {
    const { language } = vm.props;
    if (features && features.showHomeWithoutUrl && language) {
        var showHomeWithoutUrl = features.showHomeWithoutUrl;
        if (typeof showHomeWithoutUrl === 'object') {
            let countryLanguageKey = language.countryLanguageKey && language.countryLanguageKey.toLowerCase().replace('_', '-');
            if (showHomeWithoutUrl[countryLanguageKey]) {
                return showHomeWithoutUrl[countryLanguageKey];
            }
        } else {
            return showHomeWithoutUrl;
        }
    }
    return false;
}

// contactDisplayType
// 1: all contact
// 2: exclude social media (default)
// 3: only social media
// 4: customer service list (refer eb88 mobile contact us)
export function gu_getContactList(language, type, contactDisplayType = 2) {
    const socialMediaList = ['Facebook', 'Instagram', 'Youtube', 'Twitter', 'Pinterest', 'Reddit'];
    const excludeCustomerServiceList = ['QRCode'];

    return new Promise(function (resolve) {
        window.SPL_Content.getContact(language, type, undefined, true).then((res) => {
            if (res) {
                for (let key in res) {
                    if (res[key].desc) {
                        // check typeof because some desc is object (e.g. QRcode)
                        res[key].descWithoutHtmlTag = res[key].desc;
                        if (typeof res[key].desc === 'string') {
                            res[key].descWithoutHtmlTag = res[key].desc.replace(/<(.|\n)*?>/g, '');
                        }
                    }
                }
                let returnList = res;
                switch (contactDisplayType) {
                    case 2:
                        returnList = returnList.filter(function (el) {
                            return socialMediaList.indexOf(el.name) < 0;
                        });
                        break;
                    case 3:
                        returnList = returnList.filter(function (el) {
                            return socialMediaList.indexOf(el.name) >= 0;
                        });
                        break;
                    case 4:
                        // NOTE: get customer service list only
                        returnList = returnList.filter(function (el) {
                            return excludeCustomerServiceList.indexOf(el.name) < 0;
                        });
                        returnList = returnList.filter(function (el) {
                            return socialMediaList.indexOf(el.name) < 0;
                        });
                        break;
                    default:
                        break;
                }
                // Filter Name into correct name
                for (let i = 0; i < returnList.length; i++) {
                    if (returnList[i].name === 'BasicDetailsTwitter') {
                        returnList[i].name = 'Twitter';
                    }
                }
                resolve(returnList);
            } else {
                resolve([]);
            }
        });
    });
}

export function gu_popupUpdate(vm, page, data, category, title, content, isDynamicPage) {
    vm.props.dispatch(popupAction.triggerPopupUpdate(page, data, category, title, content, isDynamicPage));
}

export function gu_replaceAllGlobMerchantNameOrMerchantCode(content) {
    if (content) {
        if (content.includes('[MERCHANT]')) {
            return content.replaceAll('[MERCHANT]', window.globMerchantName);
        } else if (content.includes('[MERCHANTCODE]')) {
            return content.replaceAll('[MERCHANTCODE]', window.merchantCode);
        } else if (content.includes('{{merchant}}')) {
            return content.replaceAll('{{merchant}}', window.globMerchantName);
        } else if (content.includes('{{year}}')) {
            return content.replaceAll('{{year}}', new Date().getFullYear());
        } else {
            return content;
        }
    }
}

export function gu_getTimeZoneByCurrency(vm, timezone, type) {
    const { language, portalSettingsReducer } = vm;
    const { features } = portalSettingsReducer.portalSettings;

    if (type === 'date') {
        let newDate = '';

        if (features && features.getTimeZoneByCurrency) {
            let date = window.SPL_Other.getTimeNowByCountryLanguageKey(language.countryLanguageKey);
            newDate = date;
        }

        if (newDate !== '') {
            return newDate && newDate.fullDateTime.toString();
        } else {
            return newDate;
        }
    } else {
        let newTime = 'GMT+' + timezone;

        if (timezone < 0) {
            newTime = 'GMT' + timezone;
        }

        if (features && features.getTimeZoneByCurrency) {
            let timezone = window.SPL_Other.getTimeZoneBycountryLanguageKey(language.countryLanguageKey);
            newTime = timezone;
        }

        return newTime;
    }
}
// date format = 'YYYY-MM-DD HH:mm:ss'
export function gu_getTimeBasedOnTimeZone(gmt, date) {
    let gmtValue = 0;
    let gmtMinute = 0;

    function getGMTValue(gmtVal) {
        // extract number
        if (gmtVal.includes('-')) {
            return -gmtVal.replace(/^\D+/g, '');
        } else {
            return +gmtVal.replace(/^\D+/g, '');
        }
    }

    if (gmt.includes(':')) {
        const gmtMinuteSplit = gmt.split(':');
        if (gmtMinuteSplit.length > 1) {
            gmtMinute = gmtMinuteSplit[1];
        }
        gmtValue = getGMTValue(gmtMinuteSplit[0]);
    } else {
        gmtValue = getGMTValue(gmt);
    }

    const currentTime = new Date(date);
    // // Convert the time to GMT
    if (currentTime && currentTime != 'Invalid Date') {
        let gmtTime = currentTime.toLocaleString('en-US', { timeZone: 'UTC' });

        const newTime = new Date(gmtTime);

        newTime.setHours(newTime.getHours() + gmtValue);
        return addMinutes(newTime, gmtMinute);
        // return moment(addMinutes(newTime, gmtMinute)).format('YYYY-MM-DD HH:mm:ss');
    }
}

export function gu_getCountDownBasedOnTimeZone(gmt, date) {
    const target = new Date();
    const now = gu_getTimeBasedOnTimeZone(gmt, date);
    if (now) {
        target.setHours(24, 0, 0, 0);

        // Calculate the time difference in milliseconds
        const timeDiff = target.getTime() - now.getTime();

        return timeDiff;
    }
}

function addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
}

export function gu_getToolTip(vm, open, e, msg, relativeRef) {
    let x = 0;

    const offset = relativeRef && relativeRef.current.getBoundingClientRect().top + window.pageYOffset;
    const { top, height } = e.target.getBoundingClientRect();
    let y = top + window.pageYOffset - (offset - height / 2);

    let tempMsg = msg;

    if (Array.isArray(msg)) {
        msg.forEach((msgObj) => {
            if (msgObj.lockAmount) {
                tempMsg = msgObj.lockAmount;
            }
        });
    }

    vm.setState({ toolTip: open, tooltipMsg: tempMsg, tooltipLeft: x, tooltipTop: y });
}

export function gu_getValueType(value) {
    if (/\.(svg)$/.test(value)) {
        return <SVG src={value} />;
    } else if (/\.(jpg|jpeg|png|webp|avif|gif)$/.test(value)) {
        return <LazyLoadImage src={value} />;
    } else {
        return value;
    }
}

// isHref used for window.location.href
export function gu_navigate(props = {}, component, link, isHref, urlParams = '') {
    const { routeProps, history, language, portalSettingsReducer } = props;
    const isEnableDynamicRoute = routeProps && routeProps.settings; // routeProps.settings is served as enableBaseRoute, if no enable will be null

    const redirect = (url) => {
        const countryLanguage = language.countryLanguageKey?.toLowerCase().replace('_', '-');
        const currentDomainLanguageKey = countryLanguage?.toLowerCase().replace('_', '-');
        let isHideLangPathUrl = gu_getNestedValue(portalSettingsReducer, 'portalSettings.features.hideLangPathUrl');
        if (typeof isHideLangPathUrl === 'object') {
            isHideLangPathUrl = !!isHideLangPathUrl[currentDomainLanguageKey];
        }
        const massageLangPath = isHideLangPathUrl ? '' : '/' + currentDomainLanguageKey;
        const finalUrl = `${isHref ? massageLangPath : ''}${url + urlParams}`;

        isHref ? (window.location.href = finalUrl) : history.push(finalUrl);
    };

    // if got pass "component" and had enable "dynamic route", then redirect by component
    if (component && isEnableDynamicRoute) {
        const preRedirectUrlByComponent = gu_getNestedValue(routeProps, `settings.${window.isAffiliate ? 'affBaseRoute' : 'baseRoute'}.${component}.path`);
        const redirectUrlByComponent = Array.isArray(preRedirectUrlByComponent) ? preRedirectUrlByComponent[0] : preRedirectUrlByComponent; // if is array, force take index 0
        const defaultRoute = window.isAffiliate ? gu_getNestedValue(routeProps, `settings.affDefaultRoute`) : gu_getNestedValue(routeProps, `settings.defaultRoute`);

        // if component is home, force use defaultRoute, details refer App.js
        if (redirectUrlByComponent && !(component === 'Home' || component === 'Home_Aff')) {
            redirect(redirectUrlByComponent);
        } else {
            // if component url not found, then redirect back to defaultRoute
            if (defaultRoute) {
                redirect(defaultRoute);
            }
        }
    } else {
        // else just redirect by url
        if (link) {
            redirect(link);
        }
    }
}

export function gu_getComponentUrl(routeProps = {}, component, fallbackUrl) {
    const redirectUrlByComponent = gu_getNestedValue(routeProps, `settings.${window.isAffiliate ? 'affBaseRoute' : 'baseRoute'}.${component}.path`);
    return redirectUrlByComponent ? redirectUrlByComponent : fallbackUrl;
}

export function gu_getDefaultUrl(routeProps = {}) {
    // check if got dynamic url
    const defaultUrl = gu_getNestedValue(routeProps, `settings.${window.isAffiliate ? 'affDefaultRoute' : 'defaultRoute'}`);
    return defaultUrl ? defaultUrl : '/';
}

export function gu_getSubmenuMenu(vm, menu) {
    const { language } = vm.props || {};

    if (typeof menu.name === 'object') {
        return <span dangerouslySetInnerHTML={{ __html: gu_getContentByCurrencyLanguage(vm, menu.name) }} />;
    }

    if (menu.translation && menu.translation[language?.countryLanguageKey]) {
        return <Trans defaults={menu.translation[language.countryLanguageKey]}></Trans>;
    } else if (menu.translation && menu.translation[language?.key]) {
        return <Trans defaults={menu.translation[language.key]}></Trans>;
    } else if (menu.content) {
        return <Trans i18nKey={menu.content} defaults={menu.name} values={{ merchant: window.globMerchantName }}></Trans>;
    } else {
        return menu.name;
    }
}

export function gu_TelegramSharePopup(shareUrl, message) {
    let url = 'https://t.me/share/url?url=' + shareUrl;
    if (message) url += '&text=' + encodeURIComponent(message);
    window.open(url, '_blank', 'height=400,width=550');
}

export function gu_postExternalCampainPostback(obj, url) {
    if (obj && obj.name && obj.name.toUpperCase() === 'LINE') {
        window.SPL_Member.postExternalCampainPostback('Line', url);
    }
}

export function gu_getCustomTranslation(customTranslationObj, customTranslation, defaultTranslation) {
    return gu_getNestedValue(customTranslationObj, customTranslation) ? gu_getNestedValue(customTranslationObj, customTranslation) : defaultTranslation;
}

export function gu_getMenuTabColor(vm, currentProvider) {
    if (!vm || !currentProvider) return null;

    const { portalSettingsReducer } = vm.props;

    let color = null;

    if (gu_getNestedValue(portalSettingsReducer, 'portalSettings.features.navbarSettings.navMenu.customTabsColor')) {
        color = portalSettingsReducer.portalSettings.features.navbarSettings.navMenu.customTabsColor[currentProvider] + ' !important';
    }

    return color;
}

export function gu_dropdownUpdate(e = false, item = false, props = false, state = null, hide = null, autoRender = false) {
    let dropdownObj = {};

    if (
        (e &&
            e.target &&
            (e.target.id === 'dropdownBtn' ||
                e.target.id === 'dropdownContainer' ||
                (e.target.parentElement && (e.target.parentElement.id === 'dropdownBtn' || e.target.parentElement.id === 'dropdownContainer')))) ||
        autoRender
    ) {
        if (item) {
            let disableTelcodeDropdown = gu_getNestedValue(props, 'compSettings.disableTelcodeDropdown');
            if (item === 'telcode' && disableTelcodeDropdown) {
                return null;
            } else {
                const dropDownObj = props.dropdown ? props.dropdown : props.oriProps.dropdown;
                dropdownObj = {
                    item: item,
                    isToggle: true,
                    footerLanguageDropdown: dropDownObj.footerLanguageDropdown,
                    languageDropdown: dropDownObj.languageDropdown,
                    myAccountDropdown: dropDownObj.myAccountDropdown,
                    telcodeDropdown: dropDownObj.telcodeDropdown,
                    bankDropdown: dropDownObj.bankDropdown,
                    providerDropdown: dropDownObj.providerDropdown,
                    certainElementDropdown: hide ? null : state ? state : false,
                    guideDD: props.dropdown.guideDD ? props.dropdown.guideDD : false,
                    depositProgressDD: props.dropdown.depositProgressDD,
                    sidebarDropdown: dropDownObj.sidebarDropdown,
                    withdrawDropdown: dropDownObj.withdrawDropdown,
                };

                if (props.dropdown.certainElementDropdown && state === props.dropdown.certainElementDropdown) {
                    dropdownObj = false;
                }

                props.dispatch(dropdownAction.dropdownUpdate(dropdownObj));
            }
        }
    } else {
        const found = Object.values(props?.dropdown || {}).some((value) => !!value);
        if (found) {
            dropdownObj = false;
            props.dispatch(dropdownAction.dropdownUpdate(dropdownObj));
        }
    }
}

export function gu_deepCopy(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return obj; // Return primitive values and null as is
    }

    if (Array.isArray(obj)) {
        // Create a deep copy of an array
        const newArray = [];
        for (let i = 0; i < obj.length; i++) {
            newArray[i] = gu_deepCopy(obj[i]);
        }
        return newArray;
    }

    // Create a deep copy of an object
    const newObj = {};
    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            newObj[key] = gu_deepCopy(obj[key]);
        }
    }
    return newObj;
}

export function gu_getBannerSlideTime(vm) {
    const { intervalTime, sliderSpeed } = vm.props?.portalSettingsReducer?.portalSettings?.features || {};

    const updatedState = {
        ...vm.state,
    };

    if (intervalTime) {
        updatedState.intervalTime = intervalTime;
    }

    if (sliderSpeed) {
        updatedState.sliderSpeed = sliderSpeed;
    }

    vm.setState(updatedState);
}

export function gu_createWrapperStylePromotionByMerchant(data, features) {
    const enableCustomWrapperPromotion = features?.enableCustomWrapperPromotion || false;

    if (enableCustomWrapperPromotion) {
        if (data.includes('img')) return `<div class='wrapper-img'>${data}</div>`;
        return `<div class='wrapper'>${data}</div>`;
    }
    return data;
}

/**
 * Extract dynamic headers by className
 * @param {string} headerTag -- e.g. '.standard-setting-table-header th'
 */
export function gu_extractDynamicTableHeaders(headerTag) {
    const headers = Array.from(document.querySelectorAll(headerTag))
        .map((header) => header.textContent)
        .filter((header) => header !== null && header.trim() !== '');
    return headers;
}

/**
 * Extract data keys (assuming 'data-key' attribute contains the corresponding keys for arrayData)
 * @param {string} headerTag -- e.g. '.standard-setting-table-header th'
 * @param {Array} arrayData -- object array data
 */
export function gu_extractDynamicTableDataKeys(headerTag) {
    const contentDataKeys = Array.from(document.querySelectorAll(headerTag))
        .map((header) => header.getAttribute('data-key'))
        .filter((key) => key !== null && key.trim() !== '');

    return contentDataKeys;
}

/**
 * dynamic extract the csv data if only follow dynamic table headers (gu_extractDynamicTableHeaders) and dynamic content keys (gu_extractDynamicTableDataKeys)
 * @param {Array} arrayData
 * @param {Array} extractedDataKeys -- dynamic map property (data-key) from headers
 */
export function gu_extractDynamicTableDataValue(arrayData = [], extractedDataKeys = []) {
    const _data = arrayData.map((data) => {
        const rowData = extractedDataKeys.map((propertyKey) => {
            const propertyValue = data[propertyKey];
            return this.formatCsvAmount(propertyValue);
        });
        return rowData;
    });
    return _data;
}

export function gu_exportToCSV(moduleName, csv_data) {
    // Store csv data to be download
    let universalBOM = '\uFEFF'; // to force excel to load foreign language by utf-8 instead of asci
    let CSVFile = new Blob([universalBOM + csv_data], { type: 'text/csv;charset=utf-8;' });

    // download process
    let temp_link = document.createElement('a');
    temp_link.download = `${moduleName}_` + moment().format('YYYY-MM-DD').toString() + '.csv';
    try {
        let url = window.URL.createObjectURL(CSVFile);
        temp_link.href = url;
        temp_link.style.display = 'none';
        document.body.appendChild(temp_link);
        temp_link.click();
        document.body.removeChild(temp_link);
    } catch (err) {
        console.error(err);
    }
}

export const gu_getConversionAmountByCurrency = (isUSD, conversionRates) => (amount) => {
    if (isUSD) return window.SPL_Other.formatAmount(+amount * +conversionRates);
    return window.SPL_Other.formatAmount(+amount);
};

export function gu_getFourDPayout(language) {
    let fileUrl = `${location.origin}/draw-results/payout/mock/payout_${language}.json`;
    let request = new XMLHttpRequest();
    request.open('GET', fileUrl, false); // Third parameter is set to 'false' for synchronous
    request.send(null);

    if (request.status === 200) {
        let scriptText = request.responseText;
        return scriptText;
    } else {
        console.error('Error fetching the script. Status:', request.status);
        return null;
    }
}

export function gu_getFourDResult(date, customTimeStampDate, customIntervalRoundingUnit, provider = null) {
    const formattedDateTime = gu_formatNewDateToCustomFormat(date, 'YYYY_MM_DD');
    let filePath = `/draw-results/results/${formattedDateTime}/become.js`;
    if (provider === 'ed') {
        filePath = `/draw-results/${provider}-results/${formattedDateTime}/become.js`;
    }
    const updatedFilePath = gu_appendTimeStampIntoPath(filePath, customTimeStampDate, customIntervalRoundingUnit);

    try {
        const request = new XMLHttpRequest();
        request.open('GET', updatedFilePath, false); // Third parameter is set to 'false' for synchronous
        request.send(null);
        const scriptText = request.responseText;

        const uniqueSecretKey = 'ZGpmZ2tobmVpdGhmcnRoZ252dXRuZGh0amZodm5ybmU=';
        const decryptedData = gu_decryptData(gu_replaceAll(scriptText, /\|\|/g, '//'), uniqueSecretKey);
        return decryptedData;
    } catch (err) {
        return '';
    }
}

/**
 * convert the date format in order to retrieve correct data from BE
 * e.g. Tue Nov 07 2023 10:48:57 GMT+0800 (Singapore Standard Time) => '2023_11_07'
 * @param {Date} date
 */
export function gu_formatNewDateToCustomFormat(date, dateFormat) {
    const returnDate = moment(date).utcOffset('+08:00').format(dateFormat);
    return returnDate;
}

/**
 * Special function for 4D draw results (only appends timestamp for every 30 seconds)
 * @param {string} path
 * @returns
 */
export function gu_appendTimeStampIntoPath(path, customTimeStampDate, customIntervalRoundingUnit) {
    let connector = '?';
    if (path.includes('?')) {
        connector = '&';
    }
    const roundedTime = customTimeStampDate
        ? new Date(customTimeStampDate)
        : new Date(Math.floor(new Date() / customIntervalRoundingUnit || 30000) * customIntervalRoundingUnit || 30000); // Round down to the nearest 30 seconds
    const timeStamp = Math.trunc(roundedTime.getTime() / 1000); // Convert to seconds = 1000, minutes = 60000

    const updatedPath = path + connector + 'timeStamp=' + timeStamp;

    return updatedPath;
}

/**
 * extract the regex, convert from string to JSON
 * @param {string} data
 * @param {string} regex
 */
export function gu_extractUnusedKeywordsForDrawResults(data, regex) {
    const jsonString = data?.match(regex)?.[0];
    try {
        const jsonData = JSON.parse(jsonString) || '';
        return jsonData;
    } catch (err) {
        return '';
    }
}

export function gu_decryptData(data, secretKey) {
    try {
        const decodeBase64SecretKey = CryptoJS.enc.Base64.parse(secretKey);

        const encryptString = data;
        const randomString = 'qkemtdhted567fd988213kdecrqkemtdhted567fd988213kdecrqkemtdhted567fd988213kdec';
        const preDecodeString = encryptString.replace(randomString, '');
        const decodeBase64EncryptedData = CryptoJS.enc.Base64.parse(preDecodeString);

        const decryptedData = CryptoJS.AES.decrypt(
            {
                ciphertext: decodeBase64EncryptedData,
            },
            decodeBase64SecretKey,
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7,
            },
        ).toString(CryptoJS.enc.Utf8);
        return decryptedData;
    } catch (err) {
        console.error('decrypt data error', err);
    }
}
export function gu_limitInput(element, limitVal = 1, nextFieldId) {
    // only enter number
    if (!/^\d*$/.test(element.value)) {
        element.value = element.value.replace(/[^\d]/g, '');
    }
    // based on restrict limit input length
    if (element.value.length > limitVal) {
        element.value = element.value.slice(0, limitVal);
    }
    // change focus to next id
    if (element.value.length === limitVal) {
        document.getElementById(nextFieldId).focus();
    }
}

export function gu_leaderboardTopRanking(vm) {
    const { showLeaderboardTopRanking = [] } = vm?.portal?.settings?.features || {};
    const { currencyLang } = vm?.language || {};

    const checkLanguageShowLeaderboardTopRanking = showLeaderboardTopRanking === true || (showLeaderboardTopRanking && showLeaderboardTopRanking?.includes(currencyLang));
    return checkLanguageShowLeaderboardTopRanking && !window.isAffiliate;
}

export function roundToDecimalPlaces(number, decimalPlaces) {
    const factor = Math.pow(10, decimalPlaces);
    return Math.round(number * factor) / factor;
}

export function gu_logout(dispatch, reduxCountryLanguageKey) {
    dispatch(userAction.logout()).then(() => {
        if (!window.isAgent && !window.isAffiliate) {
            if (isLiteApp()) {
                window.SPL_LiteApp.onLogoutTapped();
            }
        }

        let path = '/';
        let langKey = '';
        let pathname = window.location.pathname;
        let pathArray = pathname.split('/');

        if (pathArray && pathArray.length >= 2 && pathArray[1].indexOf('-') !== -1) {
            langKey = pathArray[1];
        } else if (reduxCountryLanguageKey) {
            langKey = reduxCountryLanguageKey.toLowerCase().replace('_', '-');
        } else if (window && window.countryLanguageKey) {
            langKey = window.countryLanguageKey.toLowerCase().replace('_', '-');
        }

        path = '/' + langKey;

        window.location.href = path + (window.isAffiliate ? '/aff' : '');
    });
}

/**
 * If obj is not an Array, that will be return []
 * else return obj
 * @param {*} obj any
 *
 */
export function gu_forceArray(obj) {
    if (!obj || typeof obj !== 'object' || !obj?.length || !Array.isArray(obj)) return [];
    return obj;
}

export function gu_updateUserSeamless(vm) {
    if (vm.state.updateState) {
        gu_updateComponentProps(vm, 'mobileWalletProps', { disabledSeamless: !vm.state.disabledSeamless });
    }

    vm.setState({ disabledSeamless: !vm.state.disabledSeamless }, () => {
        const { disabledSeamless, hasFakeSeamLess } = vm.state;
        const { t } = vm.props;
        // TODO: after all super portal switch to use super portal 2, need to change back
        // purposely reverse flag because library side will reverse the flag also
        window.SPL_Member.updateMemberSeamlessStatus(!disabledSeamless, hasFakeSeamLess).then((res) => {
            let message = '';
            if (res.isFakeSeamlessDisabled) {
                message = t('transaction:transaction.main-wallet-auto-transfer.fake-seamless-disabled');
            } else {
                message = t('transaction:transaction.main-wallet-auto-transfer.fake-seamless-enabled');
            }
            notification.showNotification('info', message);
        });
    });
}

export function gu_getNoticeProps(props = null, moduleAuthSettings = null, translationData = null, noticeProps = {}) {
    if (!props) {
        return noticeProps;
    }

    const { language } = props;

    const pinlockKey = window.isAffiliate ? 'affPinLockedTitle' : 'pinLockedTitle';

    const noticeKey = moduleAuthSettings?.sixPinLocked ? pinlockKey : 'setSixDigitPinNotice';

    const defaultNoticeText = {
        pinLockedTitle: window.isAffiliate
            ? 'Your 6 digit PIN is locked, kindly contact Affiliate support here'
            : 'Your 6 digit PIN is locked, kindly contact Customer Service {{here}}',
        setSixDigitPinNotice: 'Your Digit PIN has not been set up yet, kindly set your PIN {{here}}',
    };

    const noticeText = translationData?.[noticeKey]?.[language?.key] || defaultNoticeText?.[noticeKey];

    return {
        moduleAuthSettings: moduleAuthSettings,
        noticeText: noticeText,
        iconSrc: noticeProps?.customIconSrc || '/public/html/default_whitelabel/template/images/icon/warning.svg',
        ...noticeProps,
    };
}

export function gu_debounce(func, wait) {
    let timeout;
    return function (...args) {
        const later = () => {
            clearTimeout(timeout);
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

export function gu_getSubmenuVpnIconTemplate(data) {
    if (isEmpty(data)) return '/';
    const { template = 'ss2', format = 'png', customUrl = '' } = data;

    return customUrl || `/public/html/default_whitelabel/shared-image/icons/vpn-${template}.${format}`;
}

export const assignAuthMethod = (authMethod = []) => authMethod.map((item) => ({ type: item }));

export function gu_appendExternalLoginSuccessUrl(url) {
    if (!url || !url.includes('http')) {
        return url;
    }

    const token = getCookie('t');
    if (!token) {
        return url;
    }

    try {
        const parsedUrl = new URL(url);
        const baseUrl = parsedUrl.origin;
        const langCode = parsedUrl.pathname.split('/')[1];

        return `${baseUrl}/external-login-success?t=${encodeURIComponent(token)}&langCode=${langCode}`;
    } catch {
        return url;
    }
}

export function gu_openUrlInPopup(url, redirectCurrentCurrency, openSameTab, isLandingPage) {
    // NOTE: from custom menu atm
    //isLandingPage is optional
    let langCurrency = window.localStorage.LANGUAGE_CURRENCY;
    langCurrency = langCurrency.toLowerCase().replace('_', '-');
    if (redirectCurrentCurrency && openSameTab) {
        if (window.isAffiliate) {
            window.open(url + '/' + langCurrency, '_self');
        } else {
            window.open('/' + langCurrency + url, '_self');
        }
        window.localStorage.setItem('LANGUAGE_CURRENCY', window.localStorage.LANGUAGE_CURRENCY);
    } else if (redirectCurrentCurrency) {
        if (window.isAffiliate) {
            window.open(url + '/' + langCurrency);
        } else {
            if (isLandingPage) {
                window.open(`${url}/${langCurrency}`);
            } else {
                window.open('/' + langCurrency + url);
            }
        }
        window.localStorage.setItem('LANGUAGE_CURRENCY', window.localStorage.LANGUAGE_CURRENCY);
    } else if (openSameTab) {
        window.open(url, '_self');
    } else {
        window.open(url);
    }

    return;
}

export function gu_inWords(num) {
    let a = [
        '',
        'one ',
        'two ',
        'three ',
        'four ',
        'five ',
        'six ',
        'seven ',
        'eight ',
        'nine ',
        'ten ',
        'eleven ',
        'twelve ',
        'thirteen ',
        'fourteen ',
        'fifteen ',
        'sixteen ',
        'seventeen ',
        'eighteen ',
        'nineteen ',
    ];
    let b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    if ((num = num.toString()).length > 9) return 'overflow';
    let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return;
    var str = '';
    str += Number(n[1]) !== 0 ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += Number(n[2]) !== 0 ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += Number(n[3]) !== 0 ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += Number(n[4]) !== 0 ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += Number(n[5]) !== 0 ? (str !== '' ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) : '';
    return str;
}

export function gu_isExternalRegister() {
    var path = window.location.pathname;
    var index = path.lastIndexOf('/');
    path = path.slice(index + 1);
    return path.includes('external-quick-register');
}

export const isRTPGameList = (gameList) => {
    const isRTP = (gameList || []).some((x) => !!parseFloat(x.rtp));
    const isSlotGame = (gameList || []).some((x) => x.category === 'SLOT');
    return {
        isRTP,
        isSlotGame,
    };
};

export function gu_getRegSocialImgSrc(desc, customImgs = {}) {
    desc = desc?.toLowerCase();
    return customImgs[desc] || `/public/html/default_whitelabel/template/images/reg-social-img/${desc}.png`;
}

// Function to capture and save the QR code
export const captureAndSaveQRCode = async (divRef) => {
    const div = divRef.current;
    if (div) {
        const qrCanvas = div.querySelector('canvas');
        if (qrCanvas) {
            // Convert the canvas to a Blob
            const blob = await new Promise((resolve) => qrCanvas.toBlob(resolve, 'image/png'));

            // Check if the browser supports the File System Access API
            if (window.showSaveFilePicker) {
                try {
                    const fileHandle = await window.showSaveFilePicker({
                        suggestedName: 'qr-code.png',
                        types: [
                            {
                                description: 'PNG Image',
                                accept: { 'image/png': ['.png'] },
                            },
                        ],
                    });
                    const writableStream = await fileHandle.createWritable();
                    await writableStream.write(blob);
                    await writableStream.close();
                } catch (err) {
                    console.error('File save was canceled or failed.', err);
                }
            } else {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'qr-code.png';
                link.click();
            }
        } else {
            console.error('QR code canvas not found inside the div.');
        }
    }
};

export const getCorrectProviderGameSet = (menu, providerPageSettings) => {
    const menuMapping = {
        SL: 'slot',
        F: 'fishing',
        L: 'lottery',
        C: 'casino',
        FG: 'fastgames',
        S: 'sport',
        P: 'poker',
        G: 'games3d',
        ES: 'esport',
    };

    const category = menuMapping[menu];
    return category ? providerPageSettings[category]?.providerGamesSet || null : null;
};

export const gu_initCheckLiteAppUrl = (pathName) => {
    // Return false immediately if it's an agent or affiliate
    if (window.isAgent || window.isAffiliate) return false;

    // Check if it's a LiteApp and the path includes 'liteapp'
    // removed isLiteApp() due to nativeApp lucky wheel new logic no need expect isLiteApp already (refer commonUtil.initCheckLiteAppUrl)
    if (pathName.includes('liteapp')) return true;
};

export const gu_handleDisibleTime = (vm) => {
    if (!vm) return;

    const fields = vm.state.fields;
    const { startDate, endDate } = fields;
    const _startDate = new Date(startDate);
    const _endDate = new Date(endDate);
    const isSameDay = _startDate.getDate() === _endDate.getDate() && _startDate.getMonth() === _endDate.getMonth() && _startDate.getFullYear() === _endDate.getFullYear();
    const timeEndSelected = _endDate.getHours();

    if (isSameDay) {
        let numbersEndDate = [];
        let numbersStarDate = [];

        if (_startDate.getHours() >= 0) {
            for (let i = 0; i <= _startDate.getHours(); i++) {
                numbersEndDate.push(new Date(0, 0, 0, i, 0));
            }

            const newTime = _startDate.getHours() + 1;
            fields.endDate = _endDate.setHours(timeEndSelected > newTime ? timeEndSelected : newTime, 0, 0, 0, 0);

            vm.setState({ disabledTimesEndDate: numbersEndDate });
        }

        if (_endDate.getHours() > 0) {
            for (let i = _endDate.getHours(); i <= 23; i++) {
                numbersStarDate.push(new Date(0, 0, 0, i, 0));
            }
            vm.setState({ disabledTimesStarDate: numbersStarDate });
        }
    } else {
        vm.setState({
            disabledTimesEndDate: [],
            disabledTimesStarDate: [],
        });
    }
};

export const gu_copy = (t, text) => {
    let copied = 'transaction:transaction.withdrawal.copied';
    let successful = window.SPL_Other.copyToClipboard(text);
    if (successful) {
        notification.showNotification('info', t(copied, 'Copied'), { autoClose: 2000 });
    }
};

export function gu_convertAmountByCurrencyRate(amount, convertRate, params) {
    if (amount < 1 || !convertRate) return '';
    convertRate = convertRate?.split('=')?.[1];

    let convertAmountByRate = amount * convertRate?.replace(/\D/g, '');
    if (params?.currency === 'VND' && params?.isCrypto)
        convertAmountByRate = amount * gu_convertRateTo5Digits(parseFloat(convertRate?.match(/[\d.]+/)[0]))?.replace(/\D/g, '');

    return `= ${convertAmountByRate?.toLocaleString()} ${params?.currency || ''}`;
}

export function gu_convertRateTo5Digits(convertRate) {
    if (!convertRate) return 1;

    const result = parseFloat(convertRate).toPrecision(5);
    return result;
}

export const gu_getMenuBaseOnLoginStatus = (vm, menus) => {
    const isLogin = vm?.props?.user?.isManualLogin === false && vm?.props?.user?.isLogin;
    const key = isLogin ? 'hideAfterLogin' : 'hideBeforeLogin';
    const viewType = vm?.props?.screen?.viewType || 'web';
    const menuSpec = menus?.filter((menu) => {
        const menuIsHide = menu?.[key]?.[viewType] && gu_getContentByCurrencyLanguage(vm, menu?.[key]?.[viewType] || menu);
        return !menu?.[key] || !menuIsHide;
    });

    return menuSpec;
};

export const gu_getGifButtonsGroupHeaderByName = (vm, menus, name = 'lottoonline') => {
    const isLogin = vm?.props?.user?.isManualLogin === false && vm?.props?.user?.isLogin;
    const key = isLogin ? 'hideAfterLogin' : 'hideBeforeLogin';

    const menuSpec = menus?.filter((menu) => {
        const menuIsHide = menu?.[key]?.hideGifButtonsGroup && gu_getContentByCurrencyLanguage(vm, menu?.[key]?.hideGifButtonsGroup || menu);

        return !menu?.[key] || !menuIsHide;
    });

    return menuSpec?.find((menu) => menu?.name?.toLowerCase() === name);
};

export function gu_modifySearchParam(history, key, value) {
    const { search } = history.location;
    const pathname = window.location.pathname;
    const params = new URLSearchParams(search);

    if (value === null || value === undefined || value === '') {
        params.delete(key);
    } else {
        params.set(key, value);
    }

    const queryString = params.toString();
    const newPath = queryString ? `${pathname}?${queryString}` : pathname;

    window.history.replaceState('', '', newPath);
}

export const gu_handleDateChanged = (vm, date, isStartDate) => {
    let fields = vm.state.fields;
    let parentvmFields = vm.props.parentvm.state.fields;

    // Check if date is an array (date range selection) or a single date
    if (Array.isArray(date)) {
        // Handling the date range case
        fields.startDate = date[0];
        vm.props.parentvm.state.fields.startDate = date?.[0];
        fields.endDate = date[1];
        vm.props.parentvm.state.fields.endDate = date?.[1];
    } else {
        // Handling single date change
        if (isStartDate) {
            fields.startDate = date;
            vm.props.parentvm.state.fields.startDate = date;
        } else {
            fields.endDate = date ? date : undefined;
            vm.props.parentvm.state.fields.endDate = date ? date : undefined;
        }
    }

    // Check if either startDate or endDate is null to disable/enable the button
    if (fields.endDate === null || fields.startDate === null) {
        vm.setState({ disabledButton: true });
    } else {
        vm.setState({ disabledButton: false });
    }

    vm.setState({ fields });
    vm.props.parentvm.setState({ parentvmFields });
};

/**
 * Determines if a file path refers to a video file based on its extension.
 *
 * @param {string} filePath - The path to the file
 * @returns {boolean} - True if the file is a video, False otherwise
 */
export function gu_isVideoFile(filePath) {
    // Comprehensive list of video file extensions
    const videoExtensions = ['.mp4', '.avi', '.mkv', '.mov', '.wmv', '.flv', '.webm', '.m4v'];

    // Handle case where there's no file path or it's not a string
    if (!filePath || typeof filePath !== 'string') {
        return false;
    }

    // Extract file extension, handle cases with or without dots
    let extension = '';
    const lastDotIndex = filePath.lastIndexOf('.');

    if (lastDotIndex !== -1) {
        extension = filePath.slice(lastDotIndex).toLowerCase();
    } else {
        return false; // No extension found
    }

    // Check if the extension is in our list of video extensions
    return videoExtensions.includes(extension);
}

export const gu_sortBySequence = (list, seq, itemSelector = (item) => item, seqSelector = (item) => item) => {
    if (!Array.isArray(list) || !Array.isArray(seq)) {
        return list;
    }

    if (seq.length === 0) {
        return [...list]; // Keep original order if seq is empty
    }

    const orderMap = new Map();
    // Create a mapping of seq items with their order
    seq.forEach((item, index) => {
        orderMap.set(seqSelector(item), index);
    });

    // Sort list based on the order in seq, push others to the end
    return [...list].sort((a, b) => {
        const indexA = orderMap.get(itemSelector(a)) ?? Infinity;
        const indexB = orderMap.get(itemSelector(b)) ?? Infinity;
        return indexA - indexB;
    });
};

export function gu_isiOSTablet() {
    let ua = navigator.userAgent || navigator.vendor || window.opera;
    let isiOSTablet = false;
    // iOS detection mainly find out iPad
    let andriod = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    let ipadPro = !!/macintosh/.test(ua.toLowerCase()) && 'ontouchend' in document;
    if (/(?:iPad|PlayBook)/.test(ua) || (andriod && !/(?:Mobile)/.test(ua)) || (/(?:Firefox)/.test(ua) && /(?:Tablet)/.test(ua)) || ipadPro) {
        isiOSTablet = true;
    }
    return isiOSTablet;
}

export function gu_isNumber(val) {
    return /^\d*$/.test(val);
}

export function gu_isValidAlphanumeric(val) {
    return /^[\dA-Za-z+#]{0,40}$/.test(val) && val.length <= 40;
}

export function gu_generateUUID() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return crypto.randomUUID();
    } else {
        // Fallback for older environments (less ideal but provides an ID)
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
}
export function gu_throttle(cb, delay = 1000) {
    let shouldWait = false;
    let waitingArgs;
    const timeoutFunc = () => {
        if (waitingArgs == null) {
            shouldWait = false;
        } else {
            cb(...waitingArgs);
            waitingArgs = null;
            setTimeout(timeoutFunc, delay);
        }
    };

    return (...args) => {
        if (shouldWait) {
            waitingArgs = args;
            return;
        }

        cb(...args);
        shouldWait = true;

        setTimeout(timeoutFunc, delay);
    };
}

export function gu_getNextLevel(currentLevel) {
    if (!currentLevel) return '';
    const match = currentLevel.match(/(\D+)(\d+)/);
    if (match) {
        const prefix = match[1];
        const number = parseInt(match[2], 10);
        return `${prefix}${number + 1}`;
    }
    return '';
}

export const gu_throttleTransform = gu_throttle((vm, rawValue, field) => {
    const diacriticMap = new Map([
        ['đ', 'd'],
        ['Đ', 'D'],
        ['æ', 'ae'],
        ['Æ', 'AE'],
        ['œ', 'oe'],
        ['Œ', 'OE'],
        ['ß', 'ss'],
        ['ẞ', 'SS'],
        ['ł', 'l'],
        ['Ł', 'L'],
        ['ø', 'o'],
        ['Ø', 'O'],
        ['ĳ', 'ij'],
        ['Ĳ', 'IJ'],
    ]);

    let value = rawValue.toUpperCase();
    // format diacritic to non-diacritic
    value = value
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[\s\S]/g, (char) => diacriticMap.get(char) || char)
        // eslint-disable-next-line no-control-regex
        .replace(/[^\x00-\x7F]/g, '');

    vm.setState({
        fields: {
            ...vm.state.fields,
            [field]: value,
        },
    });
}, 200);

const defaultKeys = ['default', 'ALL', 'en'];

// Set skipArrayItemDiscriminator to preserve an array item's root object when one of its data fields matches a discriminator key (for example, game.id and currency IDR, language key "id").
// isArrayItem is internal recursion context; nested fields inside the item still resolve normally.
export const gu_proceedNestedObject = (obj, commonKeys = [], options = {}, isArrayItem = false) => {
    if (typeof obj !== 'object' || !obj) return obj;

    const keys = Object.keys(obj);
    const combinedKeys = [...commonKeys, ...defaultKeys];

    const existedKey = options.skipArrayItemDiscriminator && isArrayItem ? null : combinedKeys.find((key) => keys.includes(key));
    if (existedKey) {
        return gu_proceedNestedObject(obj[existedKey], commonKeys, options);
    }

    for (const key in obj) {
        obj[key] = gu_proceedNestedObject(obj[key], commonKeys, options, Array.isArray(obj));
    }

    return obj;
};

export const gu_proceedNestedObjectWithVM = (vm, obj, options) => {
    if (!vm) {
        console.error('plz passed vm');
        return obj;
    }

    const viewType = vm.props.screen?.viewType;
    const key = vm.props.language?.key;
    const currency = options?.currency || vm.props.user?.account?.actualCurrency || vm.props.user?.account?.currency || vm.props.language?.currencyLang;
    const countryLanguageKey = vm.props.language?.countryLanguageKey;
    const authenType = vm.props.user?.isLogin ? 'afterLogin' : 'beforeLogin';
    const platform = window.isAffiliate ? 'affiliate' : 'member';
    const featureName = options?.featureName;

    return gu_proceedNestedObject(
        options?.disabledDeepCopy ? obj : gu_deepCopy(obj),
        [viewType, key, currency, countryLanguageKey, authenType, platform, featureName].filter(Boolean),
        options,
    );
};

export const gu_isDisableChangePasswordWithVM = (vm) => {
    if (!vm) {
        console.error('plz passed vm');
        return false;
    }

    return !!gu_proceedNestedObjectWithVM(vm, vm.props?.portal?.settings?.features?.disableChangePassword);
};

/**
 *
 * @param {boolean | string[] | null | undefined} fieldValue
 * @param {string} currency
 * @param {boolean} defaultValue
 * @returns {boolean}
 */
export function gu_isFieldHiddenBasedOnCurrency(fieldValue, currency, defaultValue = false) {
    if (fieldValue === null || fieldValue === undefined) return defaultValue;
    if (typeof fieldValue === 'boolean') return fieldValue;
    if (typeof fieldValue === 'string' || Array.isArray(fieldValue)) return fieldValue.includes(currency);
    if (typeof fieldValue === 'object') return fieldValue[currency] ?? defaultValue;
    return defaultValue;
}

export function gu_filterCommonKeyRaw(parentElement = false, childElement = false, filterSettings = {}) {
    let paramsRaw = {
        loop: filterSettings?.loop || false,
        baseOnUserCurrency: filterSettings?.baseOnUserCurrency || false,
        customFilterKeys: filterSettings?.customFilterKeys || [],
    };

    const obj = gu_getNestedValue(parentElement, childElement);
    const params = paramsRaw;

    const { loop, customFilterKeys, baseOnUserCurrency, vm } = params;
    let selectedKey = null;

    if (obj || obj === false) {
        let supportLangCurrencyList = getListOfSupportedLanguageForUrl();
        const supportViewType = ['web', 'mobile'];
        const supportUserStatus = ['isLogin', 'notLogin'];
        const supportAffiliateStatus = ['isAffiliate', 'notAffiliate'];
        let supportKeysList = supportLangCurrencyList.concat(supportViewType, supportUserStatus, supportAffiliateStatus);

        if (customFilterKeys && customFilterKeys.length > 0) {
            for (let i = 0; i < customFilterKeys.length; i++) {
                if (supportKeysList.indexOf(customFilterKeys[i]) === -1) supportKeysList.push(customFilterKeys[i]);
            }
        }

        if (!selectedKey) {
            let countryLanguageKey = localStorage.LANGUAGE_CURRENCY,
                currencyLang = localStorage.currencyLang,
                langKey = localStorage.language,
                userCurrencyLang = localStorage.userCurrencyLang;

            const viewWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
            const viewMode = getCookie('viewMode');
            let viewType = 'web';

            if (viewMode === 'mobile') {
                viewType = 'mobile';
            } else if (viewMode === 'web') {
                viewType = 'web';
            } else if (viewWidth < 768) {
                viewType = 'mobile';
            } else {
                viewType = 'web';
            }

            let isLogin = 'notLogin',
                token = getCookie('t');

            if (token) {
                isLogin = 'isLogin';
            }

            let isAffiliate = window.isAffiliate ? 'isAffiliate' : 'notAffiliate';

            selectedKey = [countryLanguageKey, currencyLang, langKey, viewType, isLogin, isAffiliate];

            if (token && baseOnUserCurrency) {
                selectedKey = [countryLanguageKey, userCurrencyLang, langKey, viewType, isLogin, isAffiliate];
            }

            if (vm) {
                const { language, screen, user } = vm.props;
                selectedKey[countryLanguageKey] = language.countryLanguageKey;
                selectedKey[currencyLang] = language.currencyLang;
                selectedKey[langKey] = language.key;
                selectedKey[viewType] = screen.viewType === 'mobile' ? 'mobile' : 'web';
                selectedKey[isLogin] = user.isLogin ? 'isLogin' : 'notLogin';
            }
        }

        if (customFilterKeys && customFilterKeys.length > 0) {
            for (let i = 0; i < customFilterKeys.length; i++) {
                if (selectedKey.indexOf(customFilterKeys[i]) === -1) selectedKey.push(customFilterKeys[i]);
            }
        }

        let uselessKeys = [];
        let selectedKeys = [];

        let handlerKey = function handlerKey(objPass) {
            for (var key in objPass) {
                if (supportKeysList.indexOf(key) > -1) {
                    if (selectedKey.indexOf(key) <= -1 && uselessKeys.indexOf(key) <= -1) {
                        uselessKeys.push(key);
                    }

                    if (selectedKey.indexOf(key) > -1 && selectedKeys.indexOf(key) <= -1) {
                        selectedKeys.push(key);
                    }
                }

                if (loop && objPass[key] && objPass[key].constructor === Object) {
                    handlerKey(objPass[key]);
                }
            }
        };

        handlerKey(obj);

        let commonKey = {
            uselessKeys,
            selectedKeys,
        };

        let updateDataBaseWithKey = function updateDataBaseWithKey(obj) {
            let tempObj = obj.constructor === Object ? { ...obj } : obj;

            let uselessObjIndex = Object.keys(tempObj).filter((key) => commonKey.uselessKeys.indexOf(key) > -1)[0];
            let selectedObjIndex = Object.keys(tempObj).filter((key) => commonKey.selectedKeys.indexOf(key) > -1)[0];

            if (commonKey.uselessKeys.length > 0) {
                for (let k = 0; k < commonKey.uselessKeys.length; k++) {
                    let key = commonKey.uselessKeys[k];
                    delete tempObj[key];
                }
            }

            if (commonKey.selectedKeys.length > 0 && selectedObjIndex) {
                let tempObjData = tempObj[selectedObjIndex];

                delete tempObj[selectedObjIndex];

                if (tempObjData && tempObj['default']) {
                    delete tempObj['default'];
                }

                if (tempObjData && tempObjData.constructor !== Object) {
                    tempObj = tempObjData;
                } else {
                    Object.assign(tempObj, tempObjData);
                }
            }

            if (tempObj && tempObj.constructor === Object) {
                uselessObjIndex = Object.keys(tempObj).filter((key) => commonKey.uselessKeys.indexOf(key) > -1)[0];
                selectedObjIndex = Object.keys(tempObj).filter((key) => commonKey.selectedKeys.indexOf(key) > -1)[0];

                if (loop && (uselessObjIndex || selectedObjIndex)) {
                    return updateDataBaseWithKey(tempObj);
                }

                if ('default' in tempObj) {
                    tempObj = tempObj['default'];
                }

                if (Object.keys(obj).length === 0) {
                    return obj;
                }

                if (Object.keys(tempObj).length === 0) {
                    return tempObj;
                }
            }

            return tempObj;
        };

        return updateDataBaseWithKey(obj);
    } else {
        return false;
    }
}

export function gu_checkIfStillValidLogin() {
    const jwtToken = window?.SPL_Auth?.getToken();

    if (!jwtToken) {
        return false;
    }
    return true;
}

export function gu_checkIfStillValidLogin2() {
    const jwtToken = window?.SPL_Auth?.getToken();
    const jwtExpiredMsg = window?.SPL_Translation?.getTranslatedErrorMsg('sessionTimeout400', 'general');

    if (!jwtToken) {
        window?.SPL_Auth?.clearTokenAndAlert(jwtExpiredMsg);
        return;
    }
}

export function gu_clearTokenAndAlert400() {
    const jwtExpiredMsg = window?.SPL_Translation?.getTranslatedErrorMsg('sessionTimeout400', 'general');
    window?.SPL_Auth?.clearTokenAndAlert(jwtExpiredMsg);
}

/**
 * Update query param in current URL
 * @param {string} key - The query param key
 * @param {string|null} value - The value, set null to remove
 * @param {boolean} replace - true = replaceState, false = pushState
 */
export function updateQueryParam(key, value, replace = true) {
    const url = new URL(window.location.href);

    if (value === null || value === undefined) {
        url.searchParams.delete(key);
    } else {
        url.searchParams.set(key, value);
    }

    if (replace) {
        window.history.replaceState({}, '', url);
    } else {
        window.history.pushState({}, '', url);
    }
}

/**
 * Normalize string for comparison
 * - Handles null/undefined safely
 * - Trims spaces
 * - Lowercases
 * - Normalizes unicode (e.g., é vs é)
 */
function normalizeInput(str) {
    if (!str || typeof str !== 'string') return '';
    return str
        .trim()
        .toLowerCase()
        .normalize('NFC') // handle unicode variations
        .replace(/\s+/g, ' '); // collapse multiple spaces
}

/**
 * Check if two values are the same (case-insensitive, safe)
 */
export function gu_isSameIgnoreCase(val1, val2) {
    return normalizeInput(val1) === normalizeInput(val2);
}

/**
 * Format a numeric value into a thousand-separator string.
 * Example: 10000.00 => 10,000
 * Note:
 * - This function should NOT be used for formatting min/max limit values.
 *   For limit fields, use `window.SPL_Other.formatAmountNoDecimal/formatAmount`,
 *   To correctly handles “unlimited” or special min/max rules.
 **/
export const gu_thousandSeparatorFormat = (num) => {
    const stringNum = String(num).replace(/,/g, '').trim();

    // 00 => remove , .99 => keep
    // Detect decimal
    const hasDecimal = stringNum.includes('.');
    const decimalPart = hasDecimal ? stringNum.split('.')[1] : '';

    const forcedNum = Number(stringNum);
    if (isNaN(forcedNum) || !Number.isFinite(forcedNum)) {
        return num;
    }

    let decimals = 0;
    // If input has decimal:
    if (decimalPart) {
        decimals = /^[0]+$/.test(decimalPart) ? 0 : decimalPart?.length;
    }
    return forcedNum.toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
};

//for beta use only
export const gu_downloadAPK = async (os, appDownloadSettings, settings) => {
    const { appDownloadData, iosDownloadLink, androidDownloadLink } = appDownloadSettings;

    // Specific for Safari on iOS, open a blank window immediately
    let windowReference = window;
    if (os === 'ios' && appDownloadData?.isIOSRedirect) {
        windowReference = window.open('', '_blank');
    }

    try {
        const affiliateId = await getLiteAppAffiliate();
        if (affiliateId) setLiteAppAffiliate(affiliateId);
    } catch (e) {
        console.log('error in gu_downloadAPK', e);
    }

    if (os === 'ios') {
        const iOSLink = iosDownloadLink || appDownloadData?.iosDownloadLink || '';
        if (appDownloadData?.isIOSRedirect) {
            if (windowReference && windowReference.location) {
                windowReference.location.href = iOSLink;
            }
        } else {
            gu_downloadCustomIosApp(appDownloadSettings, settings);
        }
    } else if (os === 'android') {
        if (appDownloadData?.isAndroidRedirect) {
            window.open(androidDownloadLink || appDownloadData?.androidDownloadLink, '');
        } else {
            gu_downloadCustomAndroidApp(appDownloadSettings, settings);
        }
    }
};

export const gu_downloadCustomIosApp = (appDownloadSettings, { customIOSDownloadLink, ...settings }, type) => {
    // custom link = hardcode link, will direct get the link from the custom settings and navigate
    if (customIOSDownloadLink) {
        window.location.href = customIOSDownloadLink;
    } else {
        if (type === 'camouflageapp') {
            gu_getCamoIosLink(appDownloadSettings, settings);
        } else {
            gu_getLiteAppIosLink(appDownloadSettings, settings);
        }
    }
};

export const gu_getCamoIosLink = ({ appDownloadData, camouflageAppDownloadData, camouflageapp }, { language, history }) => {
    if (camouflageAppDownloadData && camouflageAppDownloadData.dynamicApkLink && camouflageAppDownloadData.iosDownloadLink) {
        window.location.href = camouflageAppDownloadData.iosDownloadLink;
    } else {
        let affCode = getCookie('AffCode');
        if (camouflageapp?.ios) {
            let url = getContentByCurrencyLanguage(camouflageapp?.iosLanguage?.[language?.key] ? camouflageapp.iosLanguage : camouflageapp?.ios);
            url = url ? url.replaceAll('<affiliate ID>', affCode) : '';

            if (appDownloadData.isNormalSign) {
                window.location.href = 'itms-services://?action=download-manifest&url=' + window.location.protocol + '//' + window.location.hostname + url;
            } else {
                window.location.href = url;
            }
        } else {
            let found = (appDownloadData?.tabList || []).some((el) => el.tabName === 'iosapp' || el.tabName === 'androidapp');
            if (found) {
                history.push('/download');
            }
        }
    }
};

export const gu_getLiteAppIosLink = ({ appDownloadData, iosLanguage, ios, isNormalSign, ...appDownloadSettings }, { language, ...settings }) => {
    if (appDownloadData?.dynamicApkLink && appDownloadData?.iosDownloadLink) {
        window.location.href = appDownloadData.iosDownloadLink;
    } else {
        let affCode = getCookie('AffCode');
        if (ios) {
            let url = getContentByCurrencyLanguage(iosLanguage?.[language.key] || ios);
            url = url ? url.replaceAll('<affiliate ID>', affCode) : '';

            if (isNormalSign) {
                window.location.href = 'itms-services://?action=download-manifest&url=' + window.location.protocol + '//' + window.location.hostname + url;
            } else {
                window.location.href = url;
            }
        } else {
            gu_getCamoIosLink(appDownloadSettings, settings);
        }
    }
};

export const gu_downloadCustomAndroidApp = ({ camouflageAppDownloadData, appDownloadData }, { customAndroidDownloadLink, history }, type) => {
    let downloadLink = null;
    let apkName = 'app.apk';

    // custom link = hardcode link, will direct get the link from the custom settings and download
    if (customAndroidDownloadLink) {
        downloadLink = customAndroidDownloadLink;
    } else {
        if (type === 'camouflageapp') {
            if (camouflageAppDownloadData?.apkDownloadLink) {
                downloadLink = getContentByCurrencyLanguage(camouflageAppDownloadData.apkDownloadLink);
                apkName = camouflageAppDownloadData?.apkName || apkName;
            }
        } else {
            if (appDownloadData?.apkDownloadLink) {
                downloadLink = getContentByCurrencyLanguage(appDownloadData.apkDownloadLink);
                apkName = appDownloadData?.apkName || apkName;
            } else if (camouflageAppDownloadData?.apkDownloadLink) {
                getContentByCurrencyLanguage(camouflageAppDownloadData.apkDownloadLink);
                apkName = camouflageAppDownloadData?.apkName || apkName;
            } else {
                let found = (appDownloadData?.tabList || []).some((el) => el.tabName === 'iosapp' || el.tabName === 'androidapp');
                if (found) {
                    history.push('/download');
                }
            }
        }
    }

    if (!downloadLink) return;

    if (downloadLink.includes('androidCamouflage')) {
        window.location.href = downloadLink;
    } else {
        core.downloadUrl(downloadLink, apkName);
    }
};

export const gu_updateIsBalanceMasked = (isBalanceMasked, dispatch) => {
    window.SPL_Cookie.setCookie('isBalanceMasked', isBalanceMasked, 30);
    dispatch(userAction.updateIsBalanceMasked(isBalanceMasked));
};

export function gu_flattenObject(obj, parentKey = '', result = {}, allowNestedName = true) {
    forOwn(obj, (value, key) => {
        const newKey = allowNestedName && parentKey ? `${parentKey}.${key}` : key;

        if (isPlainObject(value)) {
            gu_flattenObject(value, newKey, result, allowNestedName);
        } else {
            result[newKey] = value;
        }
    });
    return result;
}

export function gu_changeLanguageArrangementSort(languageModalOrdering, list) {
    if (languageModalOrdering && list) {
        let tempLang = [];
        let order = '';
        let currencyOrder = languageModalOrdering.country;
        let countryOrder = languageModalOrdering.countryName;

        if (countryOrder) {
            order = countryOrder;
        } else {
            order = currencyOrder;
        }

        if (order && order.length > 0) {
            for (let i = 0; i < order.length; i++) {
                let menu = list.filter(function (e) {
                    return e.currency === order[i] || e.countryName === order[i];
                })[0];

                if (menu) {
                    tempLang.push(menu);
                }
            }

            for (let a = 0; a < tempLang.length; a++) {
                let flag = languageModalOrdering;
                let lang = tempLang[a].languages;

                for (var key in flag) {
                    if (Object.prototype.hasOwnProperty.call(flag, key)) {
                        if (tempLang[a].currency === key || tempLang[a].countryName === key) {
                            let order = '';
                            let currencyOrder = flag[tempLang[a].currency];
                            let countryOrder = flag[tempLang[a].countryName];

                            if (countryOrder) {
                                order = countryOrder;
                            } else {
                                order = currencyOrder;
                            }

                            gu_orderArray(order, lang);
                            tempLang[a].languages = lang;
                        }
                    }
                }
            }

            list = tempLang;
        }

        return list;
    }
}

export function gu_orderArray(array_with_order, array_to_order) {
    var ordered_array = [],
        len = array_to_order.length,
        len_copy = len,
        index,
        current;

    while (len--) {
        current = array_to_order[len];
        index = array_with_order.indexOf(current.key);
        ordered_array[index] = current;
    }

    //change the array
    Array.prototype.splice.apply(array_to_order, [0, len_copy].concat(ordered_array));
}

export function gu_getDepositImgPath(vm, type) {
    let imgPath = '/public/html/images/deposit/';
    if (vm) {
        let currency = vm.props && vm.props.user && vm.props.user.account ? vm.props.user.account.currency : null;
        let tempSettings = gu_getSettingFromPortalSettings({
            vm: vm,
            settingName: 'depositSettings',
        });
        if (tempSettings && tempSettings.useStandardImgFormat) {
            switch (type) {
                case 'option':
                    imgPath = `/public/html/images/deposit/channel/${currency}/`;
                    break;
                case 'channel':
                    imgPath = `/public/html/images/deposit/channel/${currency}/`;
                    break;
                case 'bank':
                    imgPath = `/public/html/images/deposit/bank/${currency}/`;
                    break;
                case 'bank-icon':
                    imgPath = `/public/html/images/deposit/bank/`;
                    break;
                case 'crypto':
                    imgPath = `public/html/images/crypto/`;
                    break;
                default:
                    break;
            }
        }
    }
    return imgPath;
}

export function gu_formatCurrentLanguage(lng) {
    return lng ? lng.toLowerCase().replace('_', '-') : 'en-my';
}

export function gu_checkIsArrayAndHasLength(array) {
    return Array.isArray(array) && array.length > 0;
}

export async function gu_triggerExternalMerchantAction(action, extraParam) {
    if (action === 'depositSuccess') {
        let depositSuccessBefore = window.SPL_Cookie.getCookie('depositSuccessBefore');
        if (depositSuccessBefore && depositSuccessBefore !== '') {
            action = 'secondDepositSuccess';
        } else {
            window.SPL_Cookie.setCookie('depositSuccessBefore', '1', 30);
        }
    }

    if (window.externalMerchantAction && window.externalMerchantAction[action]) {
        let externalFunc = window.externalMerchantAction[action];
        if (['depositSuccess', 'depositThirdPartySuccess'].includes(action) && window.externalMerchantAction?.firstTimeDeposit) {
            const isDeposited = await window.SPL_Member.getFirstTimeDepositStatus();
            if (isDeposited) return window.externalMerchantAction.firstTimeDeposit(extraParam);
        }
        externalFunc(extraParam);
    }
}

export function gu_initComm100(props, isLogin, account) {
    if (window.isInjectComm100) {
        let comm100Params = {
            // isLogin: isLogin,
            login: account && account.login ? account.login : '',
            groupType: account && account.membershipLevel ? account.membershipLevel : '',
            groupName: account && account.groupName ? account.groupName : '',
            // isAgent: window.isAgent,
            // isAffiliate: window.isAffiliate,
            merchantName: window.globMerchantName,
        };
        // can't clear spl yet, need update for me88 and maple. (But existing ticket changes too many liao, so hold first)
        // window.SPL_Other.initComm100(comm100Params);
        getComm100Details(comm100Params);
    }
}

export const gu_matchPath = (path, pathname) => {
    if (!path) return false;
    if (path === '/' || path === '/home') return pathname === '/' || pathname === '/home';
    return pathname === path || pathname.startsWith(path + '/');
};
